<template>
  <v-container fluid class="homedepot">
    <v-row no-gutters class="homedepot-main">
      <v-col cols="12" md="8" class="left-pane pr-2">
        <v-card  class="ticket-strip" flat>
          <div class="ticket-strip-title mb-0">
            <span>
              Tickets entrantes
              <v-btn @click="fetchIncomingTickets()" icon><v-icon small>mdi-refresh</v-icon></v-btn>
            </span>
            <div class="cash-actions">
              <v-btn
                small
                rounded
                class="elevation-0"
                color="primary"
                v-if="!cashRegister.activeSession"
                @click="openCashRegisterDialog"
              >
                Iniciar caja
              </v-btn>
              <template v-else>
                <v-btn small rounded outlined color="primary" @click="openCashCutDialog('cut')">
                  Retiro
                </v-btn>
                <v-btn small rounded class="elevation-0" color="primary" @click="openCashCutDialog('close')">
                  Corte
                </v-btn>
              </template>
            </div>
          </div>
          <div class="ticket-strip-list" v-if="incomingTickets.length">
            <v-card
              v-for="ticket in incomingTickets"
              :key="ticket.id"
              class="ticket-card"
              :class="{ 'ticket-card--selected': selectedIncomingTicket && String(selectedIncomingTicket.id) === String(ticket.id) }"
              outlined
              @click="applyIncomingTicket(ticket)"
            >
              <v-row class="ma-0">
                <div>
                  <!--div class="ticket-card-id">Ticket #{{ ticket.id }}</div-->
                  <div class="ticket-card-name">{{ ticket.company?.attributes?.name || ticket.company?.name }}</div>
                  <div class="ticket-card-meta">
                    {{ ticket.company?.attributes?.razon_social || ticket.company?.razon_social || 'Sin razon social' }}
                  </div>
                </div>
                <v-spacer/>
                <v-btn x-small icon @click.stop="deleteIncomingTicket(ticket)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </v-row>
            </v-card>
          </div>
        </v-card>

        <v-card v-if="cashdroConfigured && cashdroPayments.length" class="cashdro-strip" flat>
          <div class="cashdro-strip-title">
            <span><v-icon small color="success">mdi-cash-register</v-icon> Cobros CashDro</span>
            <span class="cashdro-count">{{ cashdroPayments.length }}</span>
          </div>
          <div class="cashdro-payment-list">
            <div v-for="payment in cashdroPayments" :key="payment.intentId" class="cashdro-payment">
              <div>
                <strong>{{ formatMoney(payment.amount) }}</strong>
                <span>{{ payment.reference }}</span>
                <small v-if="cashdroPaymentReconciliation(payment)" class="cashdro-reconciliation">
                  {{ cashdroPaymentReconciliation(payment) }}
                </small>
              </div>
              <div class="cashdro-payment-actions">
                <v-btn v-if="cashdroCanChangeMethod(payment)" x-small text color="primary" :disabled="cashdroMethodChange.dialog || cashdroCompletion.loading || payment.canceling || payment.completing" @click="openCashdroMethodChange(payment)">Cambiar método</v-btn>
                <span v-if="!['failed', 'canceled'].includes(payment.status)" :class="['cashdro-status', 'cashdro-status--' + payment.status]">
                  {{ cashdroPaymentLabel(payment) }}
                </span>
                <v-btn v-if="payment.status === 'collected'" x-small color="primary" @click="printCashdroTicket(payment)">Imprimir</v-btn>
                <v-btn v-else-if="cashdroPaymentNeedsManualCompletion(payment)" x-small color="primary" :loading="payment.completing" @click="completeCashdroPayment(payment)">Completar</v-btn>
                <v-btn v-if="cashdroCanModify(payment)" x-small text color="primary" @click="editCashdroSale(payment)">Modificar venta</v-btn>
                <v-btn v-if="!['collected', 'canceled'].includes(payment.status)" x-small text color="error" :loading="payment.canceling" @click="cancelCashdroPayment(payment)">Cancelar</v-btn>
              </div>
            </div>
          </div>
        </v-card>

        <!--v-card class="search-card" flat>
          <v-row class="ma-0" align="center">
            <v-col cols="12" md="9" class="py-2"-->
            <v-row class="ma-0">
              <v-col cols="4" md="2" class="pa-0 ma-0">
                <v-text-field
                  v-model="searchQuantity"
                  hide-details
                  filled
                  rounded
                  dense
                  inputmode="decimal"
                  pattern="^\\d*\\.?\\d*$"
                  class="mx-2 mb-4"
                  @input="searchQuantity = sanitizeQuantity($event)"
                  @keydown="blockQuantityKey"
                  @paste="handleQuantityPaste"
                  @blur="normalizeSearchQuantity"
                ></v-text-field>
              </v-col>
              <v-col cols="8" md="10" class="pa-0 ma-0">
                <v-text-field
                  ref="searchField"
                  v-model="searchInput"
                  :loading="searching"
                  hide-details
                  placeholder="Buscar por SKU, código o nombre"
                  prepend-inner-icon="mdi-magnify"
                  append-icon="mdi-barcode"
                  filled
                  rounded
                  dense
                  @keydown.enter="runSearch"
                  class="mx-2 mb-4"
                  @click:append.stop="openScanner"
                ></v-text-field>
              </v-col>
            </v-row>
            <!--/v-col>
            <v-col cols="12" md="3" class="py-2">
              <v-btn
                block
                color="primary"
                class="elevation-0"
                :loading="searching"
                @click="runSearch"
              >
                Buscar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-->

        <v-card :class="incomingTickets.length?'mini-cart-card':'cart-card'" flat>
          <div class="cart-header">
            Articulos en carrito
            <span class="cart-count">({{ cartCount }})</span>
          </div>
          <v-divider></v-divider>
          <v-list class="cart-list" v-if="StoreCart.length">
            <v-list-item
              v-for="(item, index) in StoreCart"
              :key="item.product.id"
              class="cart-item"
            >
              <div class="item-qty">{{ item.quantity }}x</div>
              <div class="item-details">
                <div class="item-name">{{ item.product.name }}</div>
                <div class="item-meta">SKU: {{ item.product.code_one || '-' }}</div>
                <div class="item-meta">Inventario: {{ item.product.inventory }}</div>
                <div class="item-price">
                  <span v-if="!item.product.edit">
                    Precio unitario: {{ formatMoney(priceWithIva(discountedUnitPrice(item))) }}
                    <v-btn
                      icon
                      x-small
                      @click="enablePriceEdit(item)"
                    >
                      <v-icon x-small>mdi-pencil</v-icon>
                    </v-btn>
                  </span>
                  <v-text-field
                    v-else
                    class="price-edit"
                    hide-details
                    dense
                    prefix="$"
                    suffix="c/u con IVA"
                    inputmode="decimal"
                    pattern="^\\d*\\.?\\d*$"
                    v-model="item.product.edit_price_with_iva"
                    @input="item.product.edit_price_with_iva = sanitizeQuantity($event)"
                    @keydown.enter="finishPriceEdit(item)"
                    @blur="finishPriceEdit(item)"
                  ></v-text-field>
                  <v-text-field
                    v-if="!item.product.sat_key_code"
                    class="sat-edit"
                    hide-details
                    dense
                    label="Codigo SAT"
                    v-model="item.product.new_sat_key_code"
                  ></v-text-field>
                </div>
              </div>
              <div class="item-total">{{ formatMoney(lineTotal(item)) }}</div>
              <div class="item-actions">
                <v-btn icon small @click="downItem(index)">
                  <v-icon small>mdi-minus</v-icon>
                </v-btn>
                <v-btn icon small @click="upItem(item.product.id, index)">
                  <v-icon small>mdi-plus</v-icon>
                </v-btn>
                <v-btn icon small color="error" @click="removeItem(index)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </div>
            </v-list-item>
          </v-list>
          <div v-else class="empty-cart">
            Aun no hay articulos en el carrito.
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="4" class="right-pane">
        <div class="summary-card">
          <div class="summary-title">Resumen de compra</div>
          <div class="summary-meta">
            <div><strong>Fecha:</strong> {{ today }}</div>
            <div><strong>Articulos:</strong> {{ cartCount }}</div>
          </div>

          <v-divider class="my-4"></v-divider>

          <v-autocomplete
            v-model="clientId"
            :items="companyLists"
            :loading="isLoadingCompany"
            :search-input.sync="searchCompanies"
            :hide-no-data="!searchCompanies"
            item-value="id"
            item-text="name"
            label="Cliente"
            placeholder="Escribe para buscar"
            outlined
            dense
            class="client-autocomplete"
          >
            <template v-slot:item="{ item, attrs, on }">
              <v-list-item v-on="on" v-bind="attrs">
                <v-list-item-content>
                  <v-list-item-title v-if="item.name">
                    <span v-if="item.macro">{{ item.macro }}</span>{{ item.name }}
                    <div v-if="item.razon_social" class="client-subtitle">{{ item.razon_social }}</div>
                  </v-list-item-title>
                  <v-list-item-title v-else-if="item.razon_social">{{ item.razon_social }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <template slot="no-data">
              <div class="px-4 py-1">
                No existen empresas relacionadas.
                <v-btn rounded class="mx-3" color="primary" @click="createCompanyDialog=true" x-small>
                  Crear
                </v-btn>
              </div>
            </template>

          </v-autocomplete>

          <!--v-switch hide-details v-model="cortesia" inset label="Cortesia"></v-switch-->
          <v-switch :disabled="!selectedClientHasCreditDays" hide-details v-model="payment_method_ppd" inset label="Credito"></v-switch>
          <v-switch hide-details v-model="has_desc" inset label="Descuento"></v-switch>

          <div v-if="has_desc" class="discount-box">
            <div class="discount-toggle">
              <v-btn icon @click="desc = desc === 'amount' ? 'percent' : 'amount'">
                <v-icon>{{ desc === 'amount' ? 'mdi-currency-usd' : 'mdi-percent' }}</v-icon>
              </v-btn>
            </div>
            <v-text-field
            class="pt-6"
              rounded
              outlined
              dense
              label="Descuento"
              v-model="rebajo"
            ></v-text-field>
          </div>

          <v-switch :disabled="isWalkInClient" hide-details v-model="ticket_type" inset label="Factura"></v-switch>

          <div class="payment-section mt-6">
            <div class="payment-section-header">
              <div class="section-label">Metodo de pago</div>
              <v-switch
                v-if="selectedPaymentFormConfig && selectedPaymentFormConfig.requires_terminal"
                v-model="clipTerminalEnabled"
                class="clip-terminal-switch"
                dense
                hide-details
                inset
                label="Usar Clip"
              ></v-switch>
              <v-switch
                v-if="isCashPayment && cashdroConfigured"
                v-model="cashdroEnabled"
                class="clip-terminal-switch"
                dense
                hide-details
                inset
                label="Cobrar con CashDro"
              ></v-switch>
            </div>
            <v-chip-group v-model="ticket.payment_form" column>
              <v-chip
                v-for="form in visiblePaymentForms"
                :key="form.value"
                :value="form.value"
                class="payment-chip"
                outlined
              >
                {{ form.text }}
              </v-chip>
            </v-chip-group>
          </div>

          <div v-if="isCashdroPayment" class="cash-section cashdro-section">
            <div class="section-label">Cobro con CashDro</div>
            <div class="cashdro-help">Al continuar, el cliente puede pagar en la máquina y esta caja queda libre para atender el siguiente ticket.</div>
            <div v-if="hasActiveCashdroPayment" class="cash-warning">
              CashDro está atendiendo otro cobro. Espera a que termine o registra este pago manualmente.
            </div>
          </div>

          <div v-else-if="isCashPayment" class="cash-section">
            <div class="section-label">Pago en efectivo</div>
            <v-text-field
              v-model.number="cashReceived"
              type="number"
              prefix="$"
              label="Recibido"
              outlined
              dense
              hide-details
              class="cash-input"
            ></v-text-field>
            <div class="cash-change" :class="{ negative: cashChange < 0 }">
              <span v-if="cashReceived !== null && cashReceived !== ''">
                {{ cashChange >= 0 ? 'Cambio:' : 'Faltan:' }} {{ formatMoney(Math.abs(cashChange)) }}
              </span>
              <span v-else>Ingresa el monto recibido.</span>
            </div>
            <div v-if="isCashPaymentMissingAmount" class="cash-warning">
              El monto recibido debe cubrir el total para continuar.
            </div>
          </div>

        </div>
      </v-col>
    </v-row>

    <v-row class="bottom-bar pa-0 ma-0">
        <v-col cols="8">
            <v-row class="ma-0">
                <v-col cols="4">
                    <v-row class="ma-0">
                        <v-spacer/>
                        <div class="total-block">
                            <div class="label">Subtotal</div>
                            <div class="value">{{ formatMoney(subtotal) }}</div>
                        </div>
                        <v-spacer/>
                    </v-row>
                </v-col>
                <v-col cols="4">
                    <v-row class="ma-0">
                        <v-spacer/>
                        <div class="total-block">
                            <div class="label">IVA</div>
                            <div class="value">{{ formatMoney(iva) }}</div>
                        </div>
                        <v-spacer/>
                    </v-row>
                </v-col>
                <v-col cols="4">
                    <v-row class="ma-0">
                        <v-spacer/>
                        <div class="total-block">
                            <div class="label">Total</div>
                            <div class="value">{{ formatMoney(subtotal + iva) }}</div>
                        </div>
                        <v-spacer/>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="4" class="action-col pa-0">
            <v-row class="action-row ma-0" no-gutters>
                <v-col cols="6" class="action-cell">
                    <v-btn
                        block
                        class="action-btn action-btn--quote elevation-0"
                        color="#8a8a8a"
                        dark
                        :loading="loader"
                        :disabled="isQuotationSaveDisabled || !permissions('can_quote')"
                        @click="saveQuotation"
                    >
                        Cotizar
                    </v-btn>
                </v-col>
                <v-col cols="6" class="action-cell">
                    <v-btn
                        block
                        class="action-btn action-btn--continue elevation-0"
                        color="#e25104"
                        dark
                        :loading="loader"
                        :disabled="isSaveDisabled"
                        @click="preSave"
                    >
                        Continuar
                    </v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>

    <v-dialog v-model="resultsDialog" max-width="900px">
      <v-card>
        <v-card-title>Resultados de busqueda</v-card-title>
        <v-divider></v-divider>
        <v-list>
          <v-list-item
            v-for="result in searchResults"
            :key="result.id"
            class="result-item"
          >
            <v-list-item-content>
              <v-list-item-title>{{ result.name }}</v-list-item-title>
              <v-list-item-subtitle>
                SKU: {{ result.code_one || '-' }} | Inventario: {{ result.inventory }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <div class="result-price">{{ formatMoney(result.price*1.16) }}</div>
            <v-btn small color="primary" @click="selectResult(result)">Agregar</v-btn>
          </v-list-item>
        </v-list>
        <v-divider v-if="searchMeta.last_page > 1"></v-divider>
        <v-card-actions v-if="searchMeta.last_page > 1">
          <v-spacer/>
          <v-pagination
            v-model="searchPage"
            :length="searchMeta.last_page"
            total-visible="7"
            @input="fetchSearchPage"
          ></v-pagination>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="authDialog" max-width="500px">
      <v-card class="pa-6">
        <v-card-title class="pa-0 pb-4">Ingrese Codigo de Autorizacion</v-card-title>
        <v-text-field
        type="password"
          class="ma-0"
          v-model="auth_code"
          @keydown.enter="check_auth_code = !check_auth_code"
          label="Codigo de Autorizacion"
          outlined
        ></v-text-field>
      </v-card>
    </v-dialog>

    <v-dialog v-model="zeroPriceDialog.open" max-width="720px" persistent>
      <v-card class="pa-6">
        <v-card-title class="pa-0 pb-2 red--text text--darken-2">
          Producto sin precio para esta lista
        </v-card-title>
        <v-card-subtitle class="pa-0 mb-4">
          Para continuar, un admin debe autorizar y capturar el precio del catalogo.
        </v-card-subtitle>

        <v-alert type="warning" dense text class="mb-4">
          {{ zeroPriceDialog.product?.name || 'Producto' }} no tiene precio en
          <strong>{{ currentClientPriceLabel() }}</strong>.
        </v-alert>

        <template v-if="availablePricesForProduct(zeroPriceDialog.product).length">
          <div class="mb-2 font-weight-bold">Precios disponibles</div>
          <div class="available-prices mb-4">
          <v-chip
            v-for="price in availablePricesForProduct(zeroPriceDialog.product)"
            :key="price.key"
            class="mr-2 mb-2"
            outlined
            @click="zeroPriceDialog.priceWithIva = price.gross.toFixed(2)"
          >
            {{ price.label }}: {{ formatMoney(price.gross) }}
          </v-chip>
          </div>
        </template>

        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="zeroPriceDialog.priceWithIva"
              label="Nuevo precio al cliente con IVA"
              prefix="$"
              outlined
              dense
              inputmode="decimal"
              :hint="zeroPriceCatalogHint()"
              persistent-hint
              @input="zeroPriceDialog.priceWithIva = sanitizeQuantity($event)"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="zeroPriceDialog.authCode"
              label="Codigo de autorizacion"
              type="password"
              outlined
              dense
              @keydown.enter="saveZeroPriceProduct"
            />
          </v-col>
        </v-row>

        <v-card-actions class="px-0 pb-0">
          <v-btn text color="error" @click="removeZeroPriceProduct">
            Quitar producto
          </v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            text
            :loading="zeroPriceDialog.loading"
            :disabled="zeroPriceDialog.loading || !canSaveZeroPriceProduct"
            @click="saveZeroPriceProduct"
          >
            Guardar precio
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cashdroMethodChange.dialog" persistent max-width="480px">
      <v-card class="pa-5">
        <v-card-title class="px-0 pt-0">Cambiar método de pago</v-card-title>
        <v-card-text class="px-0">
          <p>{{ cashdroMethodChange.reference }} · Venta {{ cashdroMethodChange.saleId }}</p>
          <p>Se conserva esta misma venta. No vuelvas a capturar los productos.</p>
          <v-alert v-if="cashdroMethodChange.error" type="error" dense outlined>{{ cashdroMethodChange.error }}</v-alert>
          <template v-if="!cashdroMethodChange.ready">
            <p>Primero se consultará CashDro. Si sigue cobrando, se solicitará su cancelación y se verificará el cierre antes de continuar.</p>
          </template>
          <template v-else>
            <p>Retenido en CashDro: <strong>{{ formatMoney(cashdroMethodChange.retained) }}</strong></p>
            <p>Restante por otro método: <strong>{{ formatMoney(cashdroMethodChange.remaining) }}</strong></p>
            <v-select v-model="cashdroMethodChange.form" :items="cashdroChangeMethodForms" item-text="text" item-value="value" label="Nuevo método" outlined dense :disabled="cashdroMethodChange.loading" />
            <p>Confirma el pago realizado fuera de CashDro. Este botón no realiza cargos con Clip ni transferencias.</p>
            <v-text-field v-model="cashdroMethodChange.received" label="Importe ya recibido por el nuevo método" prefix="$" type="number" step="0.01" outlined dense :disabled="cashdroMethodChange.loading" />
            <v-checkbox v-model="cashdroMethodChange.confirmed" label="Confirmo que ya recibí el importe restante con el método seleccionado" :disabled="cashdroMethodChange.loading" hide-details />
          </template>
        </v-card-text>
        <v-card-actions class="px-0 pb-0">
          <v-btn text :disabled="cashdroMethodChange.loading" @click="closeCashdroMethodChange">Cerrar</v-btn>
          <v-spacer />
          <v-btn v-if="!cashdroMethodChange.ready" color="primary" :loading="cashdroMethodChange.loading" @click="prepareCashdroMethodChange">Cerrar CashDro y continuar</v-btn>
          <v-btn v-else color="primary" :loading="cashdroMethodChange.loading" :disabled="!cashdroMethodChangeValid || cashdroMethodChange.loading" @click="submitCashdroMethodChange">Registrar pago e imprimir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cashdroCompletion.dialog" persistent max-width="460px">
      <v-card class="pa-5">
        <v-card-title class="px-0 pt-0">Completar cobro CashDro</v-card-title>
        <v-card-text class="px-0">
          <div class="mb-3">{{ cashdroCompletion.reference }}</div>
          <v-alert v-if="cashdroCompletion.error" type="error" dense outlined>{{ cashdroCompletion.error }}</v-alert>
          <template v-if="cashdroCompletion.shortage > 0">
            <p>Falta cubrir <strong>{{ formatMoney(cashdroCompletion.shortage) }}</strong> de la venta.</p>
            <v-text-field
              v-model="cashdroCompletion.manualReceived"
              label="Efectivo ya recibido manualmente"
              prefix="$"
              type="number"
              min="0"
              step="0.01"
              inputmode="decimal"
              outlined
              dense
              :disabled="cashdroCompletion.loading"
              :error-messages="cashdroCompletionAmountError"
            />
          </template>
          <p v-else-if="cashdroCompletion.pending > 0">Confirma la entrega manual de <strong>{{ formatMoney(cashdroCompletion.pending) }}</strong> de cambio al cliente.</p>
          <p v-else>La venta ya está cubierta. Confirma para registrar la cobranza y preparar el ticket.</p>
          <v-checkbox
            v-model="cashdroCompletion.confirmed"
            :label="cashdroCompletion.shortage > 0 ? 'Confirmo que ya recibí el efectivo indicado' : (cashdroCompletion.pending > 0 ? 'Confirmo que ya entregué el cambio al cliente' : 'Confirmo que el pago está completo')"
            :disabled="cashdroCompletion.loading"
            hide-details
          />
        </v-card-text>
        <v-card-actions class="px-0 pb-0">
          <v-btn text :disabled="cashdroCompletion.loading" @click="cashdroCompletion.dialog = false">Cancelar</v-btn>
          <v-spacer />
          <v-btn color="primary" :loading="cashdroCompletion.loading" :disabled="!cashdroCompletionValid || cashdroCompletion.loading" @click="submitCashdroCompletion">Completar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogTicket" max-width="350px">
      <bdbTicket
        v-if="backend_link === 'https://backendbdb.unocrm.mx/'"
        @cerrar="cerrarTicket"
        @cerrarTicket="cerrarTicket"
        :managed-close="Boolean(cashdroPrintPaymentId)"
        v-bind:ticket="ticket"
        :display-total="Number(ticket?.total || 0) || subtotal + iva"
      />
      <ticket
        v-else
        :managed-close="Boolean(cashdroPrintPaymentId)"
        @cerrar="cerrarTicket"
        @cerrarTicket="cerrarTicket"
        @cancel-sale="cancelSavedSale"
        v-bind:ticket="ticket"
        :discount="discountTotal"
        :display-total="Number(ticket?.total || 0) || subtotal + iva"
        :allow-cancel-sale="canCancelSavedSale && !ticket_type"
        :cancel-sale-loading="cancelSaleLoading"
      />
    </v-dialog>

    <v-dialog v-model="invoiceDialog" max-width="1000px" persistent>
      <invoice
        v-if="invoiceDialog"
        :invoice="invoicePayload"
        :allow-cancel-sale="canCancelSavedSale"
        :cancel-sale-loading="cancelSaleLoading"
        @cerrarInvocie="handleInvoiceClose"
        @cancel-sale="cancelSavedSale"
      />
    </v-dialog>

    <v-dialog v-model="terminalPayment.dialog" max-width="430px" persistent>
      <v-card class="pa-5">
        <v-card-title class="px-0 pt-0">Cobro en terminal</v-card-title>
        <v-card-text class="px-0">
          <v-alert
            :type="terminalPayment.status === 'failed' ? 'error' : 'info'"
            dense
            text
          >
            {{ terminalPaymentMessage }}
          </v-alert>
          <div class="terminal-payment-total">
            {{ formatMoney(terminalPayment.amount) }}
          </div>
          <div class="grey--text text--darken-1">
            Referencia: {{ terminalPayment.reference || '-' }}
          </div>
          <template v-if="canManuallyConfirmClipPayment">
            <v-alert type="warning" dense text class="mt-4 mb-2">
              Clip sigue procesando este cobro. Confirma solamente si la terminal ya muestra el recibo del pago.
            </v-alert>
            <v-select
              v-model="terminalPayment.manualPaymentForm"
              :items="manualTerminalCardForms"
              item-text="text"
              item-value="value"
              label="Tipo de tarjeta cobrada"
              outlined
              dense
              :disabled="terminalPayment.manualLoading"
            ></v-select>
            <v-text-field
              v-model.trim="terminalPayment.manualReceiptNumber"
              label="Número de recibo de Clip"
              outlined
              dense
              :disabled="terminalPayment.manualLoading"
            ></v-text-field>
            <v-checkbox
              v-model="terminalPayment.manualConfirmed"
              label="Confirmo que el cargo fue aprobado en la terminal"
              dense
              hide-details
              :disabled="terminalPayment.manualLoading"
            ></v-checkbox>
          </template>
        </v-card-text>
        <v-card-actions class="px-0 pb-0">
          <v-btn text color="error" :loading="terminalPayment.canceling" @click="handleTerminalCancelAction">
            {{ terminalPaymentIsClosed ? 'Regresar al carrito' : 'Cancelar cobro' }}
          </v-btn>
          <v-spacer />
          <v-btn
            v-if="terminalPayment.status === 'failed'"
            color="primary"
            text
            :loading="terminalPayment.manualLoading"
            @click="continueWithoutClip"
          >
            Registrar sin terminal
          </v-btn>
          <v-btn
            v-if="canManuallyConfirmClipPayment"
            color="primary"
            text
            :disabled="!canSubmitManualClipPayment"
            :loading="terminalPayment.manualLoading"
            @click="confirmClipPayment"
          >
            Confirmar cobro realizado
          </v-btn>
          <v-progress-circular
            v-if="terminalPayment.loading"
            indeterminate
            color="primary"
            size="24"
          ></v-progress-circular>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cashRegister.openDialog" max-width="430px">
      <v-card class="pa-5">
        <v-card-title class="px-0 pt-0">Iniciar caja</v-card-title>
        <v-text-field
          v-model.number="cashRegister.openingAmount"
          label="Fondo inicial"
          prefix="$"
          type="number"
          min="0"
        />
        <v-textarea v-model="cashRegister.notes" label="Notas" rows="2" auto-grow />
        <v-card-actions class="px-0 pb-0">
          <v-spacer />
          <v-btn text @click="cashRegister.openDialog = false">Cancelar</v-btn>
          <v-btn color="primary" text :loading="cashRegister.loading" @click="startCashRegister">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cashRegister.cutDialog" max-width="720px">
      <v-card class="pa-5">
        <v-card-title class="px-0 pt-0">
          {{ cashRegister.action === 'close' ? 'Cerrar caja' : 'Corte de caja' }}
        </v-card-title>
        <v-row class="ma-0">
          <v-col
            v-for="denomination in cashRegister.denominations"
            :key="denomination"
            cols="6"
            sm="4"
            md="3"
            class="px-2 py-1"
          >
            <v-text-field
              v-model.number="cashRegister.counts[String(denomination)]"
              :label="money(denomination)"
              type="number"
              min="0"
              dense
              outlined
            />
          </v-col>
        </v-row>
        <v-row class="ma-0 mt-2" align="center">
          <v-spacer />
          <strong>Total capturado: {{ money(cashRegisterCountedTotal) }}</strong>
        </v-row>
        <v-textarea v-model="cashRegister.notes" label="Notas" rows="2" auto-grow />
        <v-card-actions class="px-0 pb-0">
          <v-spacer />
          <v-btn text @click="cashRegister.cutDialog = false">Cancelar</v-btn>
          <v-btn color="primary" text :loading="cashRegister.loading" @click="saveCashCut">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.message }}
    </v-snackbar>

    <!-- Crear empresa -->
    <v-dialog v-model="createCompanyDialog" max-width="750px">
      <createCompany v-if="createCompanyDialog" @closeCreateDialogClient="closeCreateDialogClient"/>
    </v-dialog>

    <!-- Dialogo scanner -->
    <v-dialog v-model="scanner" max-width="350px">
        <v-quagga v-if="scanner" 
        :onDetected="logIt" 
        :readerTypes="['ean_reader']"
        :readerSize="readerSize"
        :aspectRatio="aspectRatio"
        ></v-quagga>
    </v-dialog> 


  </v-container>
</template>

<script>
import axios from "axios";
import Ticket from "../pos/Ticket";
import BdbTicket from "../pos/BdbTicket";
import fiscal_catalogs from "../../mixins/fiscal_catalogs";
import CreateCompany from "../clients/companies/create"
import Invoice from "../sales/invoice";

export default {
  mixins: [fiscal_catalogs],
  components: {
    ticket: Ticket,
    bdbTicket: BdbTicket,
    invoice: Invoice,
    'createCompany':CreateCompany,
  },
  data: () => ({
    createCompanyDialog: false,
    searchInput: "",
    searchQuantity: "1",
    searching: false,
    searchResults: [],
    resultsDialog: false,
    searchTerm: "",
    searchPage: 1,
    searchMeta: {
      current_page: 1,
      last_page: 1,
      total: 0,
      per_page: 20,
    },
    cashReceived: "",
    cashdroEnabled: false,
    cashdroPayments: [],
    cashdroPollingTimer: null,
    cashdroPolling: false,
    cashdroPrintPaymentId: null,
    cashdroClosingTicket: false,
    cashdroCompletion: {
      dialog: false, intentId: null, reference: '', shortage: 0, pending: 0,
      manualReceived: '', confirmed: false, loading: false, error: '',
    },
    cashdroMethodChange: {
      dialog: false, intentId: null, reference: '', saleId: null,
      form: '01', received: '', retained: 0, remaining: 0,
      confirmed: false, ready: false, loading: false, error: '', operation: null,
    },
    cashRegister: {
      activeSession: null,
      loading: false,
      openDialog: false,
      cutDialog: false,
      action: "cut",
      openingAmount: 0,
      notes: "",
      denominations: [1000, 500, 200, 100, 50, 20, 10, 5, 2, 1, 0.5],
      counts: {},
    },
    selectedIncomingTicket: null,
    incomingTickets: [],
    incomingTicketsLoading: false,
    hydratingTicket: false,
    incomingTicketDirty: false,
    pendingSaleId: null,
    clientId: "",
    isLoadingCompany: false,
    searchCompanies: null,
    entries: {
      companies: [
        {
          id: "19",
          attributes: {
            id: 19,
            name: "Mostrador",
            macro: null,
            razon_social: "MOSTRADOR",
            price_list: { name: "Precio 4" },
            credit_days: "",
          },
        },
      ],
    },
    cortesia: false,
    has_desc: false,
    desc: "percent",
    rebajo: 0,
    is_quotation: false,
    payment_method_ppd: false,
    ticket_type: false,
    loader: false,
    authDialog: false,
    auth_code: "",
    check_auth_code: false,
    zeroPriceDialog: {
      open: false,
      loading: false,
      product: null,
      priceWithIva: "",
      authCode: "",
    },
    modifiedProductPrice: false,
    dialogTicket: false,
    invoiceDialog: false,
    invoicePayload: {},
    savedSale: null,
    createdCollectionId: null,
    cancelSaleLoading: false,
    terminalPayment: {
      dialog: false,
      loading: false,
      canceling: false,
      id: null,
      status: '',
      reference: '',
      amount: 0,
      errorMessage: '',
      clipError: '',
      retryable: false,
      pollErrors: 0,
      pollTimer: null,
      manualLoading: false,
      manualConfirmationTimer: null,
      manualConfirmationAvailable: false,
      manualPaymentForm: null,
      manualReceiptNumber: '',
      manualConfirmed: false,
    },
    scanner: false,
    readerSize: { width: 640, height: 480 },
    aspectRatio: { min: 1, max: 2 },
    selectedPaymentForm: "01",
    clipTerminalEnabled: true,
    paymentMethodsCache: [],
    snackbar: {
      show: false,
      message: null,
      color: null,
    },
    ticket: {
      company_id: null,
      user_id: "",
      note: "",
      items: [
        {
          quantity: 1,
          item: "",
          price: "",
        },
      ],
      status: "vendido",
      bar: 1,
      subtotal: "",
      date: "",
      iva: "",
      total: "",
      invoice: "",
      created_by_user_id: "",
      last_updated_by_user_id: "",
      payment_form: "01",
      payment_method: "PUE",
      authorized_by: "",
      authorization_reason: "",
    },
  }),
  computed: {
    backend_link() {
      return process.env.VUE_APP_BACKEND_ROUTE;
    },
    today() {
      return new Date().toLocaleDateString("es-MX", {
        year: "numeric",
        month: "short",
        day: "2-digit",
      });
    },
    StoreCart() {
      return this.$store.state.cart.carts;
    },
    cartCount() {
      return this.StoreCart.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    },
    totalQuantity() {
      return this.StoreCart.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    },
    hasAnyDiscount() {
      return this.has_desc && Number(this.rebajo || 0) > 0;
    },
    requiresDiscountAuthorization() {
      return this.cortesia || this.hasAnyDiscount;
    },
    requiredAuthorizationType() {
      return this.requiresDiscountAuthorization ? "discount" : "price";
    },
    requiresAuthorization() {
      return this.requiresDiscountAuthorization || this.modifiedProductPrice;
    },
    zeroPriceCartItems() {
      return this.StoreCart.filter((item) => Number(item?.product?.price || 0) <= 0);
    },
    hasZeroPricedCartItems() {
      return this.zeroPriceCartItems.length > 0;
    },
    canSaveZeroPriceProduct() {
      return Number(this.zeroPriceDialog.priceWithIva || 0) > 0 && String(this.zeroPriceDialog.authCode || "").trim() !== "";
    },
    companyLists() {
      return this.entries.companies.map((company) => ({
        id: company.id,
        name: company.attributes.name,
        macro: company.attributes.macro,
        razon_social: company.attributes.razon_social,
        price_list: company.attributes.price_list,
        credit_days: company.attributes.credit_days,
      }));
    },
    selectedClient() {
      return this.companyLists.find(
        (company) => String(company.id) === String(this.clientId)
      ) || null;
    },
    selectedClientHasCreditDays() {
      const creditDays = this.selectedClient?.credit_days;
      return creditDays !== null && creditDays !== undefined && String(creditDays).trim() !== "";
    },
    isWalkInClient() {
      const id = String(this.clientId || "");
      const client = this.selectedClient || this.client || {};
      const clientName = String(client.name || client.razon_social || "")
        .trim()
        .toLowerCase();

      return id === "19" || id === "191" || clientName === "mostrador" || clientName === "mostrador mayoreo";
    },
    client() {
      return this.$store.state.cart.client;
    },
    currentUser() {
      return this.$store.state.currentUser.user;
    },
    paymentMethodsList() {
      const storeMethods = this.$store.state.payment_method.payment_methods;
      return storeMethods && storeMethods.length ? storeMethods : this.paymentMethodsCache;
    },
    canCancelSavedSale() {
      return Boolean(this.savedSale?.id || this.ticket?.id);
    },
    posPaymentForms() {
      // Without Clip there is no terminal response to classify the card, so
      // the cashier must choose the exact fiscal form manually.
      if (!this.clipTerminalEnabled) {
        return this.payment_forms;
      }
      const forms = this.payment_forms.filter((form) => !['04', '28'].includes(String(form.value)));
      const firstCardIndex = this.payment_forms.findIndex((form) => ['04', '28'].includes(String(form.value)));
      const cardForm = { value: '28', text: 'Tarjeta', requires_terminal: true, terminal_provider: 'clip' };

      if (firstCardIndex < 0) {
        return [...forms, cardForm];
      }

      const beforeCards = this.payment_forms
        .slice(0, firstCardIndex)
        .filter((form) => !['04', '28'].includes(String(form.value)));
      const afterCards = this.payment_forms
        .slice(firstCardIndex)
        .filter((form) => !['04', '28'].includes(String(form.value)));
      return [...beforeCards, cardForm, ...afterCards];
    },
    visiblePaymentForms() {
      return this.posPaymentForms.filter((form) => !["02", "15"].includes(String(form.value)));
    },
    selectedPaymentFormConfig() {
      return this.posPaymentForms.find((form) => String(form.value) === String(this.currentPaymentForm())) || null;
    },
    isCashPayment() {
      const value = this.ticket.payment_form;
      if (value === null || value === undefined || value === "") {
        return false;
      }
      if (String(value).toLowerCase() === "01") {
        return true;
      }
      const match = this.payment_forms.find((form) => String(form.value) === String(value));
      return match ? match.text === "01" : false;
    },
    cashChange() {
      const received = Number(this.cashReceived || 0);
      const total = Number(this.subtotal) + Number(this.iva);
      return received - total;
    },
    isCashPaymentMissingAmount() {
      if (this.is_quotation) {
        return false;
      }
      if (!this.isCashPayment) {
        return false;
      }
      if (this.isCashdroPayment) {
        return false;
      }
      const received = Number(this.cashReceived || 0);
      const total = this.round2(Number(this.subtotal) + Number(this.iva));
      return received < total;
    },
    selectedPaymentMethodRecord() {
      return this.paymentMethodRecord(this.currentPaymentForm());
    },
    requiresTerminalPayment() {
      return this.clipTerminalEnabled && Boolean(this.selectedPaymentFormConfig?.requires_terminal);
    },
    manualTerminalCardForms() {
      return [
        { value: '04', text: 'Tarjeta de crédito' },
        { value: '28', text: 'Tarjeta de débito' },
      ];
    },
    canManuallyConfirmClipPayment() {
      return this.terminalPayment.manualConfirmationAvailable
        && ['pending', 'processing'].includes(this.terminalPayment.status);
    },
    canSubmitManualClipPayment() {
      return this.canManuallyConfirmClipPayment
        && Boolean(this.terminalPayment.manualPaymentForm)
        && Boolean(this.terminalPayment.manualReceiptNumber)
        && this.terminalPayment.manualConfirmed;
    },
    cashdroConfigured() {
      return process.env.VUE_APP_CASHDRO_ENABLED === "true"
        && Boolean(process.env.VUE_APP_CASHDRO_URL)
        && ((Boolean(process.env.VUE_APP_CASHDRO_USER) && Boolean(process.env.VUE_APP_CASHDRO_PASSWORD))
          || Boolean(process.env.VUE_APP_CASHDRO_AGENT_TOKEN));
    },
    cashdroCompletionAmountError() {
      if (this.cashdroCompletion.shortage <= 0) return '';
      const amount = Number(this.cashdroCompletion.manualReceived);
      return !Number.isFinite(amount) || Math.round(amount * 100) < Math.round(this.cashdroCompletion.shortage * 100)
        ? 'El importe debe cubrir el restante de la venta.' : '';
    },
    cashdroCompletionValid() {
      return this.cashdroCompletion.confirmed && !this.cashdroCompletionAmountError;
    },
    cashdroChangeMethodForms() {
      return this.payment_forms.filter(form => ['01', '03', '04', '28'].includes(form.value));
    },
    cashdroMethodChangeValid() {
      const state = this.cashdroMethodChange;
      return state.ready && state.confirmed && state.remaining > 0
        && Boolean(this.paymentMethodRecord(state.form))
        && Number.isFinite(Number(state.received))
        && Math.round(Number(state.received) * 100) === Math.round(state.remaining * 100);
    },
    isCashdroPayment() {
      return !this.payment_method_ppd && !this.is_quotation && this.isCashPayment && this.cashdroConfigured && this.cashdroEnabled;
    },
    hasActiveCashdroPayment() {
      return this.cashdroPayments.some((payment) => ['starting', 'waiting', 'processing'].includes(payment.status));
    },
    terminalPaymentIsClosed() {
      // A rejected Clip request stays open on the terminal, so it must be canceled first.
      return this.terminalPayment.status === 'canceled'
        || (this.terminalPayment.status === 'failed' && !this.terminalPayment.retryable);
    },
    terminalPaymentMessage() {
      if (this.terminalPayment.errorMessage) {
        return this.terminalPayment.errorMessage;
      }
      if (this.terminalPayment.status === 'collected') {
        return 'Pago aprobado. Preparando ticket.';
      }
      if (this.terminalPayment.status === 'approved') {
        return 'Pago aprobado. Registrando cobranza.';
      }
      if (this.terminalPayment.status === 'failed' && this.terminalPayment.retryable) {
        return (this.terminalPayment.clipError || 'Tarjeta rechazada.')
          + ' El cliente puede intentar de nuevo en la terminal. Si no va a pagar con tarjeta, cancela el cobro.';
      }
      if (this.terminalPayment.status === 'failed') {
        return 'El pago fallo. Puedes registrar esta venta sin terminal o regresar al carrito para corregirla.';
      }
      if (this.terminalPayment.status === 'canceled') {
        return 'Cobro cancelado. Regresa al carrito para modificar productos o metodo de pago.';
      }
      return 'Esperando pago en la terminal.';
    },
    cashRegisterCountedTotal() {
      return this.cashRegister.denominations.reduce((sum, denomination) => {
        return sum + (Number(this.cashRegister.counts[String(denomination)] || 0) * denomination);
      }, 0);
    },
    cualMetodo() {
      return this.payment_method_ppd ? "PPD" : "PUE";
    },
    netBase() {
      return (this.StoreCart || []).reduce(
        (sum, item) => sum + this.lineSubtotal(item, this.productOriginalPrice(item.product)),
        0
      );
    },
    subtotal() {
      const total = (this.StoreCart || []).reduce((sum, item) => {
        return sum + this.lineSubtotal(item, this.discountedUnitPrice(item));
      }, 0);
      return Math.max(total, 0);
    },
    iva() {
      const rate = 0.16;
      return Math.max(this.round2(this.subtotal * rate), 0);
    },
    discountTotal() {
      const rate = 0.16;
      const totalBefore = this.netBase + this.round2(this.netBase * rate);
      const totalAfter = Number(this.subtotal) + Number(this.iva);
      const diff = totalBefore - totalAfter;
      return diff > 0 ? diff : 0;
    },
    isQuotationSaveDisabled() {
      if (!this.StoreCart.length || this.subtotal < 0.01) {
        return true;
      }
      if (this.hasZeroPricedCartItems) {
        return true;
      }
      if (!this.client || !this.client.id) {
        return true;
      }
      return this.loader;
    },
    isSaveDisabled() {
      if (!this.StoreCart.length || this.subtotal < 0.01) {
        return true;
      }
      if (this.hasZeroPricedCartItems) {
        return true;
      }
      if (!this.client || !this.client.id) {
        return true;
      }
      if 
        (this.ticket.payment_form === null ||
          this.ticket.payment_form === undefined ||
          this.ticket.payment_form === "")
       {
        return true;
      }
      if (!this.is_quotation && this.isCashPaymentMissingAmount) {
        return true;
      }
      if (this.isCashdroPayment && this.hasActiveCashdroPayment) {
        return true;
      }
      return this.loader;
    },
  },
  created() {
    this.$store.dispatch("currentUser/getUser");
    this.$store.dispatch("payment_method/getPaymentMethods");
    this.ensureClient();
    this.syncClientSelection();
    this.ensurePaymentMethods();
    this.fetchIncomingTickets();
    this.fetchCashRegisterSession();
    this.loadCashdroPayments().finally(() => this.startCashdroPolling());
    if (window.Echo) {
      window.Echo.channel('test').listen('Test', (e) => {
        const incoming = e && e.ticket ? e.ticket : e
        if (incoming && incoming.id) {
          this.incomingTickets = [incoming].concat(this.incomingTickets.filter(t => t.id !== incoming.id))
        }
      })
    }
  },
  beforeDestroy() {
    this.stopTerminalPaymentPolling();
    this.stopCashdroPolling();
  },
  watch: {
    client: {
      handler(value) {
        if (!value || !value.id) {
          return;
        }
        const id = String(value.id);
        if (id !== String(this.clientId)) {
          this.clientId = id;
        }
        this.ensureClientEntry(value);
      },
      deep: true,
    },
    clientId: {
      handler(value, oldValue) {
        if (!value) {
          return;
        }
        const selected = this.companyLists.find(
          (company) => String(company.id) === String(value)
        );
        if (selected) {
          this.$store.dispatch("cart/selectClient", selected);
        }
        if (this.isWalkInClient && this.ticket_type) {
          this.ticket_type = false;
        }
        if (!this.selectedClientHasCreditDays && this.payment_method_ppd) {
          this.payment_method_ppd = false;
        }
        if (oldValue !== undefined && String(value) !== String(oldValue)) {
          this.recalculateCartPrices();
          this.markIncomingTicketDirty();
        }
      },
    },
    searchCompanies(val) {
      if (!val || this.isLoadingCompany) {
        return;
      }
      this.isLoadingCompany = true;
      axios
        .get(
          process.env.VUE_APP_BACKEND_ROUTE +
            "api/v2/companies?filter[name_razon_social]=" +
            encodeURIComponent(val)
        )
        .then((res) => {
          this.mergeCompanies(res.data.data || []);
        })
        .finally(() => {
          this.isLoadingCompany = false;
        });
    },
    check_auth_code: {
      handler() {
        if (this.backend_link !== "https://backendbdb.unocrm.mx/" && this.matchesPosAuthorizationCode(this.auth_code, this.requiredAuthorizationType)) {
          this.authDialog = false;
          this.auth_code = "";
          this.ticket.authorization_reason = this.authorizationReason();
          if (this.selectedIncomingTicket) {
            this.processIncomingTicket();
          } else {
            this.save();
          }
          return;
        }
        if (this.backend_link === "https://backendbdb.unocrm.mx/") {
          axios
            .post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/user/authorize", {
              authorization_code: this.auth_code,
            })
            .then((resp) => {
              this.ticket.authorized_by = resp.data;
              this.ticket.authorization_reason = this.authorizationReason();
              this.authDialog = false;
              this.auth_code = "";
              if (this.selectedIncomingTicket) {
                this.processIncomingTicket();
              } else {
                this.save();
              }
            })
            .catch((error) => {
              this.snackbar = {
                show: true,
                message: error.response?.data?.message || "Código de autorización incorrecto.",
                color: "error",
              };
              this.authDialog = false;
              this.auth_code = "";
              this.is_quotation = false;
            });
        } else {
          this.snackbar = {
            show: true,
            message: "Código de autorización incorrecto.",
            color: "error",
          };
          this.authDialog = false;
          this.auth_code = "";
          this.is_quotation = false;
        }
      },
      deep: true,
    },
    "ticket.payment_form": {
      handler(value, oldValue) {
        if (!this.isCashPayment) {
          this.cashReceived = "";
        }
        if (oldValue !== undefined && value !== oldValue) {
          this.markIncomingTicketDirty();
        }
      },
    },
    clipTerminalEnabled(value) {
      // Re-enable the single-card Clip flow after a manual credit/debit choice.
      if (value && ['04', '28'].includes(String(this.ticket.payment_form))) {
        this.ticket.payment_form = '28';
      }
    },
    payment_method_ppd(value, oldValue) {
      if (oldValue !== undefined && value !== oldValue) {
        this.markIncomingTicketDirty();
      }
    },
    ticket_type(value, oldValue) {
      if (oldValue !== undefined && value !== oldValue) {
        this.markIncomingTicketDirty();
      }
    },
    cortesia(value, oldValue) {
      if (oldValue !== undefined && value !== oldValue) {
        this.markIncomingTicketDirty();
      }
    },
    has_desc(value, oldValue) {
      if (oldValue !== undefined && value !== oldValue) {
        this.markIncomingTicketDirty();
        this.refreshPendingSaleSnapshot();
      }
    },
    desc(value, oldValue) {
      if (oldValue !== undefined && value !== oldValue) {
        this.markIncomingTicketDirty();
        this.refreshPendingSaleSnapshot();
      }
    },
    rebajo(value, oldValue) {
      if (oldValue !== undefined && value !== oldValue) {
        this.markIncomingTicketDirty();
        this.refreshPendingSaleSnapshot();
      }
    },
  },
  methods: {
    openScanner() {
      this.scanner = true;
    },
    permissions(permission){
      if(this.currentUser.id==1){
        return true
      }else if(this.currentUser.permissions!=undefined){
        if(this.currentUser.permissions.includes(permission)){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    },
    currentClientPriceKey() {
      if (this.backend_link === "https://backendbdb.unocrm.mx/") {
        return "price";
      }
      if (this.client && this.client.price_list && this.client.price_list.name) {
        return this.priceList(this.client.price_list.name);
      }
      return "price_four";
    },
    currentClientPriceLabel() {
      const labels = {
        price: "Precio 1",
        price_two: "Precio 2",
        price_three: "Precio 3",
        price_four: "Precio 4",
      };
      return labels[this.currentClientPriceKey()] || "Precio 4";
    },
    zeroPriceCatalogHint() {
      const grossPrice = Number(this.zeroPriceDialog.priceWithIva || 0);
      if (!grossPrice || grossPrice <= 0) {
        return `Se guardara sin IVA en ${this.currentClientPriceLabel()}.`;
      }
      return `Se guardara sin IVA en ${this.currentClientPriceLabel()}: ${this.formatMoney(this.priceWithoutIva(grossPrice))}.`;
    },
    priceLabel(key) {
      const labels = {
        price: "Precio 1",
        price_two: "Precio 2",
        price_three: "Precio 3",
        price_four: "Precio 4",
      };
      return labels[key] || key;
    },
    availablePricesForProduct(product) {
      if (!product) {
        return [];
      }
      const prices = product.price_list_values || product;
      return ["price", "price_two", "price_three", "price_four"]
        .map((key) => ({
          key,
          label: this.priceLabel(key),
          net: Number(prices[key] || 0),
          gross: this.priceWithIva(prices[key]),
        }))
        .filter((price) => Number(price.net) > 0);
    },
    processZeroPricedCartItems() {
      if (this.zeroPriceDialog.open) {
        return;
      }
      const item = this.zeroPriceCartItems[0];
      if (!item) {
        return;
      }
      this.openZeroPriceDialog(item.product);
    },
    openZeroPriceDialog(product) {
      this.zeroPriceDialog = {
        open: true,
        loading: false,
        product,
        priceWithIva: "",
        authCode: "",
      };
    },
    removeZeroPriceProduct() {
      const productId = this.zeroPriceDialog.product?.id;
      const index = this.StoreCart.findIndex((item) => String(item.product.id) === String(productId));
      if (index >= 0) {
        this.removeItem(index);
      }
      this.zeroPriceDialog.open = false;
      this.$nextTick(() => this.processZeroPricedCartItems());
    },
    posAuthorizationCode(type) {
      const fallback = process.env.VUE_APP_POS_AUTH_CODE;
      if (type === "price") {
        return process.env.VUE_APP_POS_PRICE_AUTH_CODE || fallback;
      }
      return process.env.VUE_APP_POS_DISCOUNT_AUTH_CODE || fallback;
    },
    matchesPosAuthorizationCode(authCode, type) {
      return String(authCode || "") === String(this.posAuthorizationCode(type) || "");
    },
    async validatePosAuthorizationCode(authCode, type = "discount") {
      if (this.backend_link !== "https://backendbdb.unocrm.mx/" && this.matchesPosAuthorizationCode(authCode, type)) {
        return this.currentUser.id;
      }
      if (this.backend_link === "https://backendbdb.unocrm.mx/") {
        const response = await axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/user/authorize", {
          authorization_code: authCode,
        });
        return response.data;
      }
      throw new Error("Código de autorización incorrecto.");
    },
    updateProductPriceLocally(productId, priceKey, netPrice) {
      const applyPrice = (product) => {
        if (!product || String(product.id) !== String(productId)) {
          return;
        }
        product[priceKey] = netPrice;
        if (!product.price_list_values) {
          product.price_list_values = this.productPriceValues(product);
        }
        product.price_list_values[priceKey] = netPrice;
        product.price = netPrice;
        product.original_price = netPrice;
        product.edit = false;
        product.edit_price_with_iva = "";
      };

      this.StoreCart.forEach((item) => applyPrice(item.product));
      this.searchResults.forEach((product) => applyPrice(product));
    },
    async saveZeroPriceProduct() {
      if (!this.canSaveZeroPriceProduct || this.zeroPriceDialog.loading) {
        return;
      }
      const product = this.zeroPriceDialog.product;
      const priceKey = this.currentClientPriceKey();
      const grossPrice = Number(this.zeroPriceDialog.priceWithIva || 0);
      const netPrice = this.round2(this.priceWithoutIva(grossPrice));

      if (!product?.id || netPrice <= 0) {
        return;
      }

      this.zeroPriceDialog.loading = true;
      try {
        const authorizedBy = await this.validatePosAuthorizationCode(this.zeroPriceDialog.authCode, "price");
        await axios.patch(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/items/" + product.id, {
          [priceKey]: netPrice,
          last_updated_by_user_id: this.currentUser.id,
        });
        this.ticket.authorized_by = authorizedBy;
        this.updateProductPriceLocally(product.id, priceKey, netPrice);
        this.refreshPendingSaleSnapshot();
        if (this.isPendingSaleActive()) {
          const cartItem = this.StoreCart.find((item) => String(item.product.id) === String(product.id));
          if (cartItem) {
            this.markIncomingTicketDirty();
            this.syncPendingSaleItem(cartItem.product, cartItem.quantity);
          }
        }
        this.zeroPriceDialog.open = false;
        this.snackbar = {
          show: true,
          message: `Precio actualizado en ${this.currentClientPriceLabel()}.`,
          color: "success",
        };
        this.$nextTick(() => this.processZeroPricedCartItems());
      } catch (error) {
        this.snackbar = {
          show: true,
          message: error.response?.data?.message || error.message || "No se pudo actualizar el precio.",
          color: "error",
        };
      } finally {
        this.zeroPriceDialog.loading = false;
      }
    },
    money(value) {
      return new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(Number(value || 0));
    },
    resetCashCounts() {
      const counts = {};
      this.cashRegister.denominations.forEach((denomination) => {
        counts[String(denomination)] = 0;
      });
      this.cashRegister.counts = counts;
    },
    async fetchCashRegisterSession() {
      try {
        const { data } = await axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/cash-register/active");
        this.cashRegister.activeSession = data.data || null;
      } catch (error) {
        this.cashRegister.activeSession = null;
      }
    },
    openCashRegisterDialog() {
      this.cashRegister.openingAmount = 0;
      this.cashRegister.notes = "";
      this.cashRegister.openDialog = true;
    },
    openCashCutDialog(action) {
      this.cashRegister.action = action;
      this.cashRegister.notes = "";
      this.resetCashCounts();
      this.cashRegister.cutDialog = true;
    },
    async startCashRegister() {
      this.cashRegister.loading = true;
      try {
        await axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/cash-register/open", {
          opening_amount: this.cashRegister.openingAmount || 0,
          notes: this.cashRegister.notes,
        });
        this.cashRegister.openDialog = false;
        await this.fetchCashRegisterSession();
        this.snackbar = { show: true, color: "success", message: "Caja iniciada." };
      } catch (error) {
        this.snackbar = { show: true, color: "error", message: error.response?.data?.message || "No se pudo iniciar caja." };
      } finally {
        this.cashRegister.loading = false;
      }
    },
    async saveCashCut() {
      this.cashRegister.loading = true;
      const endpoint = this.cashRegister.action === "close" ? "close" : "cut";
      try {
        await axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/cash-register/" + endpoint, {
          denominations: this.cashRegister.counts,
          notes: this.cashRegister.notes,
        });
        this.cashRegister.cutDialog = false;
        await this.fetchCashRegisterSession();
        this.snackbar = {
          show: true,
          color: "success",
          message: this.cashRegister.action === "close" ? "Caja cerrada." : "Corte guardado.",
        };
      } catch (error) {
        this.snackbar = { show: true, color: "error", message: error.response?.data?.message || "No se pudo guardar el corte." };
      } finally {
        this.cashRegister.loading = false;
      }
    },
    logIt (data) {
      const code = data?.codeResult?.code;
      if (!code || this.searching) {
        return;
      }
      this.searchInput = code;
      this.scanner = false;
      this.$nextTick(() => {
        this.runSearch();
      });
    },
    sanitizeQuantity(value) {
      const raw = String(value ?? "");
      let cleaned = raw.replace(/[^0-9.]/g, "");
      const firstDot = cleaned.indexOf(".");
      if (firstDot !== -1) {
        cleaned = cleaned.slice(0, firstDot + 1) + cleaned.slice(firstDot + 1).replace(/\./g, "");
      }
      return cleaned;
    },
    normalizeQuantity(value) {
      const parsed = parseFloat(value);
      if (!Number.isFinite(parsed) || parsed <= 0) {
        return 1;
      }
      return parsed;
    },
    normalizeSearchQuantity() {
      this.searchQuantity = String(this.normalizeQuantity(this.searchQuantity));
    },
    blockQuantityKey(event) {
      const { key, ctrlKey, metaKey, altKey } = event;
      if (ctrlKey || metaKey || altKey) return;

      const controlKeys = [
        "Backspace",
        "Delete",
        "Tab",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
      ];
      if (controlKeys.includes(key)) return;

      if (key === ".") {
        if (String(this.searchQuantity || "").includes(".")) {
          event.preventDefault();
        }
        return;
      }

      if (!/^\d$/.test(key)) {
        event.preventDefault();
      }
    },
    handleQuantityPaste(event) {
      const text = event.clipboardData?.getData("text") ?? "";
      const sanitized = this.sanitizeQuantity(text);
      event.preventDefault();

      const target = event.target;
      const current = String(this.searchQuantity ?? "");
      const start = target?.selectionStart ?? current.length;
      const end = target?.selectionEnd ?? current.length;
      const nextValue = current.slice(0, start) + sanitized + current.slice(end);
      this.searchQuantity = this.sanitizeQuantity(nextValue);
    },
    getSearchQuantity() {
      return this.normalizeQuantity(this.searchQuantity);
    },
    fetchIncomingTickets() {
      this.incomingTicketsLoading = true;
      axios
        .get(
          process.env.VUE_APP_BACKEND_ROUTE +
            "api/v2/sales?itemsPerPage=50&filter[payment_status]=En Crédito,Vencida,En Proceso&filter[payment_method]=PUE&filter[status]=venta_pendiente&page=1"
        )
        .then((response) => {
          this.incomingTickets = response.data.data || [];
        })
        .catch(() => {
          this.snackbar = {
            message: "No se pudieron cargar los tickets pendientes.",
            color: "error",
            show: true,
          };
        })
        .finally(() => {
          this.incomingTicketsLoading = false;
        });
    },
    applyIncomingTicket(ticket) {
      if (!ticket || !ticket.items) {
        return
      }
      if (this.selectedIncomingTicket && String(this.selectedIncomingTicket.id) === String(ticket.id)) {
        this.selectedIncomingTicket = null
        this.pendingSaleId = null
        this.hydratingTicket = false
        this.incomingTicketDirty = false
        this.cortesia = false
        this.has_desc = false
        this.rebajo = 0
        this.desc = "percent"
        this.modifiedProductPrice = false
        this.ticket.authorization_reason = ""
        this.ticket.authorized_by = ""
        this.$store.commit('cart/CLEAR_CART')
        this.ensureClient()
        return
      }
      this.hydratingTicket = true
      this.incomingTicketDirty = false
      this.selectedIncomingTicket = ticket
      const company = ticket.company?.attributes || ticket.company || {}
      this.$store.commit('cart/setClient', company)
      const paymentForm = ticket.payment_form
      if (this.visiblePaymentForms.find(form => form.value === paymentForm)) {
        this.ticket.payment_form = paymentForm
      } else {
        const match = this.visiblePaymentForms.find(form => form.text === paymentForm)
        this.ticket.payment_form = match ? match.value : '01'
      }
      this.selectedPaymentForm = this.ticket.payment_form
      this.ticket_type = ticket.type === 'Serie A'
      if (this.isWalkInClient) {
        this.ticket_type = false
      }
      this.payment_method_ppd = ticket.payment_method === 'PPD'
      this.is_quotation = ticket.status === 'quotation'
      this.cortesia = ticket.status === 'cortesia'
      this.has_desc = false
      this.rebajo = 0
      this.desc = "percent"
      this.modifiedProductPrice = false
      this.ticket.authorization_reason = ticket.authorization_reason || ""
      this.ticket.authorized_by = ticket.authorized_by || ""

      this.$store.commit('cart/CLEAR_CART')
      const items = ticket.items || []
      const productMap = {}
      items.forEach(item => {
        const base = item.item || item.product || item
        if (!base || !base.id) {
          return
        }
        if (!productMap[base.id]) {
          const product = Object.assign({}, base)
          const storedDiscount = Number(item.discount || base.discount || 0)
          const storedPrice = Number(item.price != null ? item.price : product.price || 0)
          const originalPrice = item.value != null
            ? Number(item.value)
            : (storedDiscount > 0 && storedDiscount < 100
              ? storedPrice / (1 - storedDiscount / 100)
              : storedPrice)
          // Keep the catalog prices because product.price is replaced by the ticket price below.
          product.price_list_values = this.productPriceValues(base, storedPrice)
          product.original_price = this.round2(originalPrice)
          product.price = this.round2(storedPrice)
          product.sale_item_id = item.id || item.sale_item_id || product.sale_item_id
          product.edit_price_with_iva = ""
          productMap[base.id] = product
        }
        const quantity = Number(item.quantity || 1)
        this.$store.dispatch('cart/addItemWithQuantity', { item: productMap[base.id], quantity })
      })
      this.$nextTick(() => {
        this.refreshPendingSaleSnapshot()
        this.hydratingTicket = false
        this.processZeroPricedCartItems()
      })
    },
    ensureClient() {
      if (!this.client || !this.client.id) {
        this.$store.dispatch("cart/selectClient", {
          id: "19",
          name: "Mostrador",
          price_list: { name: "Precio 4" },
        });
      }
    },
    syncClientSelection() {
      if (this.client && this.client.id) {
        this.clientId = String(this.client.id);
        this.ensureClientEntry(this.client);
      }
    },
    ensureClientEntry(client) {
      if (!client || !client.id) {
        return;
      }
      const exists = this.entries.companies.some(
        (company) => String(company.id) === String(client.id)
      );
      if (exists) {
        return;
      }
      this.entries.companies = [
        {
          id: String(client.id),
          attributes: {
            id: client.id,
            name: client.name || client.razon_social || "",
            macro: client.macro || null,
            razon_social: client.razon_social || null,
            price_list: client.price_list || null,
          },
        },
        ...this.entries.companies,
      ];
    },
    mergeCompanies(companies) {
      const map = new Map(
        this.entries.companies.map((company) => [String(company.id), company])
      );
      companies.forEach((company) => {
        map.set(String(company.id), company);
      });
      this.entries.companies = Array.from(map.values());
    },
    round2(value) {
      return Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
    },
    resolveUserId(user) {
      if (user === null || user === undefined || user === "") {
        return null;
      }
      if (typeof user === "object") {
        return user.id ?? null;
      }
      return user;
    },
    incomingCreatedByUserId() {
      const ticket = this.selectedIncomingTicket || {};
      return (
        this.resolveUserId(ticket.created_by_user_id) ||
        this.resolveUserId(ticket.user_id) ||
        this.currentUser.id
      );
    },
    incomingLastUpdatedByUserId() {
      const ticket = this.selectedIncomingTicket || {};
      return (
        this.resolveUserId(ticket.last_updated_by_user_id) ||
        this.incomingCreatedByUserId()
      );
    },
    markIncomingTicketDirty() {
      if (!this.selectedIncomingTicket || this.hydratingTicket) {
        return;
      }
      this.incomingTicketDirty = true;
    },
    lineSubtotal(item, unitPrice) {
      const qty = Number(item.quantity || 0);
      return this.round2(Number(unitPrice || 0) * qty);
    },
    productOriginalPrice(product) {
      return Number(product?.original_price ?? product?.price ?? 0);
    },
    applyGlobalDiscount(unitPrice) {
      const currentPrice = Number(unitPrice || 0);
      if (!this.has_desc || Number(this.rebajo || 0) <= 0) {
        return Math.max(this.round2(currentPrice), 0);
      }
      if (this.desc === "percent") {
        return Math.max(
          this.round2(currentPrice - (currentPrice / 100) * Number(this.rebajo || 0)),
          0
        );
      }
      if (this.desc === "amount") {
        const rate = 0.16;
        const totalQty = Math.max(this.totalQuantity || 0, 1);
        const discountNet = (Number(this.rebajo) || 0) / (1 + rate);
        return Math.max(this.round2(currentPrice - discountNet / totalQty), 0);
      }
      return Math.max(this.round2(currentPrice), 0);
    },
    discountedUnitPrice(item) {
      return this.applyGlobalDiscount(item?.product?.price);
    },
    discountedUnitPriceByProduct(product) {
      return this.applyGlobalDiscount(product?.price);
    },
    unitDiscountAmountFromValues(basePrice, finalPrice) {
      const base = Number(basePrice || 0);
      const final = Number(finalPrice || 0);
      if (!Number.isFinite(base) || base <= 0) {
        return 0;
      }
      if (!Number.isFinite(final) || final >= base) {
        return 0;
      }
      return this.round2(base - final);
    },
    unitDiscountAmount(item) {
      return this.unitDiscountAmountFromValues(
        this.productOriginalPrice(item?.product),
        this.discountedUnitPrice(item)
      );
    },
    unitDiscountAmountByProduct(product) {
      return this.unitDiscountAmountFromValues(
        this.productOriginalPrice(product),
        this.discountedUnitPriceByProduct(product)
      );
    },
    lineDiscountAmount(item) {
      return this.round2(this.unitDiscountAmount(item) * Number(item?.quantity || 0));
    },
    lineDiscountAmountByProduct(product, quantity = 0) {
      return this.round2(this.unitDiscountAmountByProduct(product) * Number(quantity || 0));
    },
    effectiveDiscountPercentFromValues(basePrice, finalPrice) {
      const base = Number(basePrice || 0);
      const final = Number(finalPrice || 0);
      if (!Number.isFinite(base) || base <= 0) {
        return 0;
      }
      const discount = ((base - final) / base) * 100;
      if (!Number.isFinite(discount) || discount < 0) {
        return 0;
      }
      return this.round2(discount > 100 ? 100 : discount);
    },
    effectiveDiscountPercent(item) {
      return this.effectiveDiscountPercentFromValues(
        this.productOriginalPrice(item?.product),
        this.discountedUnitPrice(item)
      );
    },
    effectiveDiscountPercentByProduct(product) {
      return this.effectiveDiscountPercentFromValues(
        this.productOriginalPrice(product),
        this.discountedUnitPriceByProduct(product)
      );
    },
    priceWithoutIva(value) {
      return Number(value || 0) / 1.16;
    },
    priceWithIva(value) {
      return Number(value || 0) * 1.16;
    },
    lineTotal(item) {
      return this.lineSubtotal(item, this.priceWithIva(this.discountedUnitPrice(item)));
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
      });
    },
    rellenar(sat_key) {
      if (sat_key === "1010101" || sat_key === 1010101) {
        return "31162800";
      }
      return sat_key;
    },
    priceList(price) {
      switch (price) {
        case "Precio 1":
          return "price";
        case "Precio 2":
          return "price_two";
        case "Precio 3":
          return "price_three";
        case "Precio 4":
          return "price_four";
        default:
          return "price_four";
      }
    },
    productPrice(product) {
      return this.productPriceForClient(product, this.client);
    },
    productPriceValues(product, fallbackPrice = 0) {
      return {
        price: this.firstValidPrice(product.price, product.price_one, fallbackPrice),
        price_two: this.firstValidPrice(product.price_two, fallbackPrice),
        price_three: this.firstValidPrice(product.price_three, fallbackPrice),
        price_four: this.firstValidPrice(product.price_four, fallbackPrice),
      };
    },
    firstValidPrice(...values) {
      const value = values.find((candidate) => Number(candidate) > 0);
      return value === undefined ? 0 : Number(value);
    },
    productPriceForClient(product, client) {
      if (this.backend_link === "https://backendbdb.unocrm.mx/") {
        return product.price_list_values?.price ?? product.price;
      }
      if (client && client.price_list && client.price_list.name) {
        const priceKey = this.priceList(client.price_list.name);
        const prices = product.price_list_values || product;
        return prices[priceKey] * 1;
      }
      return (product.price_list_values?.price_four ?? product.price_four) * 1;
    },
    recalculateCartPrices() {
      this.StoreCart.forEach((cartItem) => {
        const product = cartItem.product;
        const price = this.round2(this.productPrice(product));

        product.price = price;
        product.original_price = price;
        product.edit = false;
        product.edit_price_with_iva = "";
      });

      this.modifiedProductPrice = false;
      this.refreshPendingSaleSnapshot();
      this.processZeroPricedCartItems();
    },
    normalizeProduct(product) {
      const price = this.round2(this.productPrice(product));
      return {
        id: product.id,
        name: product.name,
        price,
        original_price: price,
        price_list_values: this.productPriceValues(product),
        cost: product.current_cost,
        code_one: product.code_one,
        facturapi_id: product.facturapi_id,
        sat_key_code: this.rellenar(product.sat_key_code),
        new_sat_key_code: "",
        edit: false,
        edit_price_with_iva: "",
        unit: product.unit,
        inventory: product.current_inventory,
        branch_inventories: product.branch_inventories,
      };
    },
    closeCreateDialogClient: function() {
      this.createCompanyDialog = false
    },
    runSearch() {
      if (!this.searchInput) {
        return;
      }
      this.normalizeSearchQuantity();
      this.searchTerm = this.searchInput;
      this.searchPage = 1;
      this.fetchSearchResults(1, { resetInput: true });
    },
    fetchSearchPage(page) {
      this.fetchSearchResults(page);
    },
    fetchSearchResults(page = 1, { resetInput = false } = {}) {
      if (!this.searchTerm) {
        return;
      }
      this.searching = true;
      axios
        .get(
          process.env.VUE_APP_BACKEND_ROUTE +
            "api/v2/item/pos?filter[is_published]=1&filter[pos]=" +
            encodeURIComponent(this.searchTerm) +
            "&itemsPerPage=20&page=" +
            page
        )
        .then((response) => {
          const items = (response.data.data || []).map((item) => this.normalizeProduct(item));
          const meta = response.data.meta || response.data || {};
          const total = Number(meta.total ?? items.length);
          const lastPage = Number(meta.last_page ?? 1);
          const currentPage = Number(meta.current_page ?? page);

          this.searchMeta = {
            current_page: currentPage,
            last_page: lastPage,
            total,
            per_page: Number(meta.per_page ?? 20),
          };
          this.searchPage = currentPage;

          if (total === 1 && items.length === 1) {
            this.addToCart(items[0], this.getSearchQuantity());
            this.resultsDialog = false;
            this.searchResults = [];
            return;
          }
          if (items.length > 0) {
            this.searchResults = items;
            this.resultsDialog = true;
          } else {
            this.resultsDialog = false;
            this.searchResults = [];
            this.snackbar = {
              show: true,
              message: "No se encontraron productos.",
              color: "warning",
            };
          }
        })
        .catch(() => {
          this.snackbar = {
            show: true,
            message: "No se pudo buscar productos.",
            color: "error",
          };
        })
        .finally(() => {
          this.searching = false;
          if (resetInput) {
            this.searchInput = "";
            this.$nextTick(() => {
              if (this.$refs.searchField) {
                this.$refs.searchField.focus();
              }
            });
          }
        });
    },
    selectResult(item) {
      this.addToCart(item, this.getSearchQuantity());
      this.resultsDialog = false;
      this.searchResults = [];
    },
    addToCart(product, quantity = 1) {
      const qty = this.normalizeQuantity(quantity);
      this.$store.dispatch("cart/addItemWithQuantity", { item: product, quantity: qty });
      this.$nextTick(() => this.processZeroPricedCartItems());
      if (this.isPendingSaleActive()) {
        this.markIncomingTicketDirty();
        const cartItem = this.StoreCart.find((cart) => cart.product.id === product.id);
        if (cartItem) {
          this.syncPendingSaleItem(cartItem.product, cartItem.quantity);
        }
      }
      this.searchQuantity = 1
    },
    isPendingSaleActive() {
      if (!this.selectedIncomingTicket || this.hydratingTicket) {
        return false;
      }
      const status = String(this.selectedIncomingTicket.status || "").toLowerCase();
      return status === "venta_pendiente" || status === "venta pendiente";
    },
    pendingSalePayload(product, quantity) {
      return {
        quantity: Number(quantity || 0),
        item_id: product.id,
        price: this.discountedUnitPriceByProduct(product),
        discount: this.lineDiscountAmountByProduct(product, quantity),
        value: this.productOriginalPrice(product),
        quotation_id: this.selectedIncomingTicket?.id,
      };
    },
    syncPendingSaleItem(product, quantity) {
      if (!this.isPendingSaleActive() || !product || !this.selectedIncomingTicket?.id) {
        return;
      }
      const saleItemId = product.sale_item_id;
      const payload = this.pendingSalePayload(product, quantity);

      if (!payload.quantity || payload.quantity <= 0) {
        if (!saleItemId) {
          return;
        }
        axios
          .delete(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sale_items/" + saleItemId)
          .then(() => {
            product.sale_item_id = null;
            this.refreshPendingSaleSnapshot();
          });
        return;
      }

      if (saleItemId) {
        axios
          .patch(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sale_items/" + saleItemId, payload)
          .then(() => {
            this.refreshPendingSaleSnapshot();
          });
        return;
      }

      axios
        .post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sale_items", payload)
        .then((response) => {
          const saved = response.data?.data || response.data;
          if (saved && saved.id) {
            product.sale_item_id = saved.id;
          }
          this.refreshPendingSaleSnapshot();
        });
    },
    refreshPendingSaleSnapshot() {
      if (!this.selectedIncomingTicket || this.hydratingTicket) {
        return;
      }
      this.selectedIncomingTicket = Object.assign({}, this.selectedIncomingTicket, {
        subtotal: this.subtotal,
        iva: this.iva,
        total: Number(this.subtotal) + Number(this.iva),
        items: this.StoreCart.map((item) => ({
          id: item.product.sale_item_id,
          quantity: item.quantity,
          price: this.discountedUnitPrice(item),
          discount: this.lineDiscountAmount(item),
          value: this.productOriginalPrice(item.product),
          item: item.product,
        })),
      });
    },
    deleteIncomingTicket(ticket) {
      if (!ticket || !ticket.id) {
        return;
      }
      axios
        .delete(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sales/" + ticket.id)
        .then(() => {
          this.incomingTickets = this.incomingTickets.filter(
            (t) => String(t.id) !== String(ticket.id)
          );
          if (this.selectedIncomingTicket && String(this.selectedIncomingTicket.id) === String(ticket.id)) {
            this.selectedIncomingTicket = null;
            this.pendingSaleId = null;
            this.incomingTicketDirty = false;
            this.modifiedProductPrice = false;
            this.ticket.authorization_reason = "";
            this.ticket.authorized_by = "";
            this.$store.commit("cart/CLEAR_CART");
            this.ensureClient();
          }
        })
        .catch((error) => {
          this.snackbar = {
            message: error.response?.data?.message || "No se pudo eliminar la venta pendiente.",
            color: "error",
            show: true,
          };
        });
    },
    removeItem(index) {
      const cartItem = this.StoreCart[index];
      const product = cartItem?.product;
      const saleItemId = product?.sale_item_id;
      this.$store.dispatch("cart/removeItem", index);
      if (this.isPendingSaleActive() && product && saleItemId) {
        this.markIncomingTicketDirty();
        this.syncPendingSaleItem(product, 0);
      }
    },
    downItem(index) {
      const cartItem = this.StoreCart[index];
      const product = cartItem?.product;
      this.$store.dispatch("cart/downItem", index);
      if (this.isPendingSaleActive() && product) {
        this.markIncomingTicketDirty();
        const updated = this.StoreCart.find((cart) => cart.product.id === product.id);
        const quantity = updated ? updated.quantity : 0;
        this.syncPendingSaleItem(product, quantity);
      }
    },
    upItem(id, index) {
      const cartItem = this.StoreCart[index];
      const product = cartItem?.product;
      this.$store.dispatch("cart/upItem", { id, index });
      if (this.isPendingSaleActive() && product) {
        this.markIncomingTicketDirty();
        const updated = this.StoreCart.find((cart) => cart.product.id === product.id);
        if (updated) {
          this.syncPendingSaleItem(product, updated.quantity);
        }
      }
    },
    enablePriceEdit(item) {
      item.product.edit_price_with_iva = this.round2(
        this.priceWithIva(item?.product?.price)
      ).toFixed(2);
      item.product.edit = true;
      this.modifiedProductPrice = true;
    },
    finishPriceEdit(item) {
      const currentNetPrice = Number(item?.product?.price || 0);
      const sanitizedGross = this.sanitizeQuantity(item?.product?.edit_price_with_iva);
      const parsedGross = Number(sanitizedGross);

      if (sanitizedGross !== "" && Number.isFinite(parsedGross) && parsedGross >= 0) {
        item.product.price = this.round2(this.priceWithoutIva(parsedGross));
      } else {
        item.product.price = currentNetPrice;
      }

      item.product.edit_price_with_iva = "";
      item.product.edit = false;
      this.modifiedProductPrice = true;
      this.refreshPendingSaleSnapshot();
      if (this.isPendingSaleActive()) {
        this.markIncomingTicketDirty();
        this.syncPendingSaleItem(item.product, item.quantity);
      }
    },
    authorizationReason() {
      const reasons = [];
      if (this.hasAnyDiscount || this.modifiedProductPrice) {
        reasons.push("Descuento");
      }
      if (this.cortesia) {
        reasons.push("Cortesia");
      }
      return reasons.length ? `- ${reasons.join(" - ")}` : "";
    },
    preSave() {
      if (this.isCashPaymentMissingAmount) {
        this.snackbar = {
          show: true,
          message: "El monto recibido en efectivo debe cubrir el total de la venta.",
          color: "warning",
        };
        return false;
      }
      if (this.hasZeroPricedCartItems) {
        this.processZeroPricedCartItems();
        this.snackbar = {
          show: true,
          message: "Hay productos sin precio. Captura el precio autorizado para continuar.",
          color: "warning",
        };
        return false;
      }
      if (this.requiresAuthorization) {
        this.authDialog = true;
        return true;
      } else {
        if (this.selectedIncomingTicket) {
          this.processIncomingTicket();
          return true;
        }
        this.save();
        return true;
      }
    },
    saveQuotation() {
      this.is_quotation = true;
      if (!this.preSave()) {
        this.is_quotation = false;
      }
    },
    processIncomingTicket() {
      const ticket = this.selectedIncomingTicket;
      if (!ticket) {
        return;
      }
      const status = String(ticket.status || "").toLowerCase();
      // A canceled CashDro payment keeps its original sale, but editing it must
      // create the replacement sale from the cart instead of charging old items.
      if (this.pendingSaleId || status === "venta_pendiente" || status === "venta pendiente") {
        this.pendingSaleId = ticket.id;
        this.save();
        return;
      }

      this.savedSale = ticket;
      if (this.ticket_type && !this.is_quotation && !this.isCashdroPayment && !this.requiresTerminalPayment) {
        this.prepareInvoice(ticket);
        this.invoiceDialog = true;
      } else {
        this.finalizeSaleFlow();
      }
    },
    async ensurePaymentMethods() {
      if (this.paymentMethodsList.length) {
        return;
      }
      try {
        const response = await axios.get(
          process.env.VUE_APP_BACKEND_ROUTE + "api/v1/payment_method/all"
        );
        this.paymentMethodsCache = response.data || [];
      } catch (error) {
        this.snackbar = {
          show: true,
          message: "No se pudieron cargar los metodos de pago.",
          color: "error",
        };
      }
    },
    currentPaymentForm() {
      // The chip group writes directly to ticket.payment_form. Prefer it so
      // terminal controls react immediately when the cashier changes method.
      if (this.ticket?.payment_form !== null && this.ticket?.payment_form !== undefined) {
        return this.ticket.payment_form;
      }
      return this.selectedPaymentForm;
    },
    paymentMethodId(paymentFormValue) {
      const method = this.paymentMethodRecord(paymentFormValue);
      return method ? method.id : null;
    },
    normalizePaymentMethodLabel(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase();
    },
    paymentMethodRecord(paymentFormValue) {
      const cardLabels = {
        '04': 'tarjeta de credito',
        '28': 'tarjeta de debito',
      };
      const cardLabel = cardLabels[String(paymentFormValue)];
      if (cardLabel) {
        const cardMethod = this.paymentMethodsList.find((method) => (
          this.normalizePaymentMethodLabel(method.method || method.name) === cardLabel
        ));
        if (cardMethod) {
          return cardMethod;
        }
      }
      const paymentForm = this.payment_forms.find((form) => String(form.value) === String(paymentFormValue));
      if (paymentForm === null || paymentForm === undefined) {
        return null;
      }
      const normalizedLabel = this.normalizePaymentMethodLabel(paymentForm.text);
      const exactMatch = this.paymentMethodsList.find((method) => {
        const label = this.normalizePaymentMethodLabel(method.method || method.name);
        return label === normalizedLabel;
      });
      if (exactMatch) {
        return exactMatch;
      }
      const fuzzyMatch = this.paymentMethodsList.find((method) => {
        const label = this.normalizePaymentMethodLabel(method.method || method.name);
        return label.includes(normalizedLabel) || normalizedLabel.includes(label);
      });
      return fuzzyMatch || null;
    },
    prepareInvoice(sale) {
      const company = sale.company?.attributes || sale.company || {};
      const saleItems = sale.items || [];
      const saleDate =
        sale.date ||
        new Date().toLocaleString("sv-SE", { timeZone: "America/Monterrey" }).toString().slice(0, 10);
      this.invoicePayload = {
        items: saleItems.map((item) => {
          const product = item.item || item.product || {};
          const cartItem = this.StoreCart.find(
            (cart) => String(cart.product.id) === String(product.id)
          );
          const originalValue = item.value ??
            (cartItem ? this.productOriginalPrice(cartItem.product) : undefined) ??
            product.original_price ??
            item.price;

          return {
            quantity: item.quantity,
            product_id: product.facturapi_id,
            product,
            price: item.price,
            value: originalValue,
            discount: item.discount ?? 0,
          };
        }),
        products: saleItems,
        payment_form: sale.payment_form || this.currentPaymentForm(),
        payment_method: sale.payment_method || this.cualMetodo,
        use: "",
        conditions: "",
        customer: company.facturapi_id,
        company,
        date: saleDate,
        external_id: sale.id,
        series: sale.serie || sale.type || (this.ticket_type ? "Serie A" : "Serie B"),
      };
    },
    async createCollection(sale) {
      if (this.is_quotation || this.payment_method_ppd) {
        return true;
      }
      // Clip creates the collection in the backend. A delayed POS flow must not create it again.
      if (this.createdCollectionId) {
        return true;
      }
      const paymentFormValue = this.currentPaymentForm();
      if (paymentFormValue === null || paymentFormValue === undefined || paymentFormValue === "") {
        this.snackbar = {
          show: true,
          message: "Selecciona un metodo de pago para la cobranza.",
          color: "warning",
        };
        return false;
      }
      await this.ensurePaymentMethods();
      const paymentMethodId = this.paymentMethodId(paymentFormValue);
      if (paymentMethodId === null || paymentMethodId === undefined) {
        this.snackbar = {
          show: true,
          message: "No se encontró el método de pago para la cobranza.",
          color: "error",
        };
        return false;
      }
      const amount = Number(sale.total || this.subtotal + this.iva || 0);
      const companyId = sale.company?.id || sale.company_id || this.client?.id;
      const dueBalance = sale.due_balance ?? amount;
      const saleDate =
        sale.date ||
        new Date().toLocaleString("sv-SE", { timeZone: "America/Monterrey" }).toString().slice(0, 10);
      const payload = {
        company_id: companyId,
        company_ids: [companyId],
        salesID: [
          {
            id: sale.id,
            amount,
            due: dueBalance,
            new_due: dueBalance,
            invoice: "",
            invoice_date: "",
          },
        ],
        date: saleDate,
        methods: [
          {
            method: paymentMethodId,
            amount,
          },
        ],
        amount,
        created_by_user_id: this.currentUser.id,
        last_updated_by_user_id: this.currentUser.id,
        user_id: this.currentUser.id,
        serie: this.ticket_type ? "Serie A" : "Serie B",
        payment_method_id: paymentMethodId,
        companies: [companyId],
      };
      try {
        const response = await axios.post(
          process.env.VUE_APP_BACKEND_ROUTE + "api/v1/collection/create",
          Object.assign(payload)
        );
        this.createdCollectionId = response.data?.id || response.data || null;
        return true;
      } catch (error) {
        this.snackbar = {
          message: error.response?.data?.message || "Error al guardar cobranza.",
          color: "error",
          show: true,
        };
        return false;
      }
    },
    async finalizeSaleFlow() {
      if (this.cashdroPrintPaymentId && this.createdCollectionId) {
        this.dialogTicket = true;
        return;
      }
      if (this.is_quotation) {
        this.dialogTicket = true;
        return;
      }
      if (this.isCashdroPayment) {
        await this.startCashdroPayment(this.savedSale || {});
        return;
      }
      if (this.requiresTerminalPayment) {
        await this.startTerminalPayment(this.savedSale || {});
        return;
      }
      const collectionWasCreated = await this.createCollection(this.savedSale || {});
      if (!collectionWasCreated) {
        return;
      }
      this.selectedIncomingTicket = null;
      this.incomingTicketDirty = false;
      this.dialogTicket = true;
    },
    cashdroStorageKey() {
      return 'uno-cashdro-pending-payments';
    },
    async loadCashdroPayments() {
      if (!this.cashdroConfigured) {
        return;
      }
      try {
        const saved = JSON.parse(window.localStorage.getItem(this.cashdroStorageKey()) || '[]');
        this.cashdroPayments = Array.isArray(saved) ? saved : [];
      } catch (error) {
        this.cashdroPayments = [];
      }
      try {
        const response = await axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/cashdro/payments');
        const local = this.cashdroPayments;
        this.cashdroPayments = response.data.map((intent) => {
          const saved = local.find((payment) => payment.intentId === intent.id) || {};
          const sale = intent.sale?.data || intent.sale;
          return {
            ...saved, intentId: intent.id, saleId: intent.sale_id, amount: intent.amount,
            reference: intent.reference, status: intent.status === 'pending' ? 'waiting' : intent.status,
            operationId: intent.external_id || saved.operationId,
            operation: intent.operation || saved.operation,
            cashdroAmountCents: intent.cashdro_amount_cents ?? saved.cashdroAmountCents,
            collectionId: intent.collection_id, sale,
            methodChange: intent.method_change || null,
            ticket: this.cashdroTicketFromSale(sale) || saved.ticket,
            completing: false, canceling: false, confirmingPrinted: false,
          };
        });
        this.saveCashdroPayments();
      } catch (error) {
        this.snackbar = { show: true, color: 'warning', message: 'No se pudo recuperar el seguimiento CashDro del servidor. Se reintentará al entrar al punto de venta.' };
      }
    },
    cashdroTicketFromSale(sale) {
      if (!sale) return null;
      return { ...sale, items: (sale.items || []).map(item => ({ ...item, product: item.item || item.product })) };
    },
    cashdroCanModify(payment) {
      const retained = (this.cashdroCents(payment.operation?.totalin) || 0) - Math.abs(this.cashdroCents(payment.operation?.totalout) || 0);
      return payment.status === 'canceled' && payment.sale?.status === 'cashdro_draft' && retained <= 0;
    },
    saveCashdroPayments() {
      window.localStorage.setItem(this.cashdroStorageKey(), JSON.stringify(this.cashdroPayments));
    },
    cashdroPaymentLabel(payment) {
      if (payment.status === 'failed' && this.cashdroChangeUnavailable(payment) > 0) {
        return 'Cambio pendiente';
      }
      const labels = {
        starting: 'Conectando',
        waiting: 'Esperando efectivo',
        processing: 'Procesando cambio',
        collected: 'Listo para imprimir',
        failed: 'Requiere revisión',
        canceled: 'Cobro cancelado',
      };
      return labels[payment.status] || 'Pendiente';
    },
    cashdroCentsToMoney(value) {
      if (value === null || value === undefined || value === '' || Number.isNaN(Number(value))) {
        return null;
      }
      return Math.abs(Number(value)) / 100;
    },
    cashdroChangeUnavailable(payment) {
      return this.cashdroCentsToMoney(payment?.operation?.amountchangenotavailable) || 0;
    },
    cashdroPendingChangeCents(operation, amount, requestedCents = null) {
      const received = this.cashdroCents(operation?.totalin);
      const returned = Math.abs(this.cashdroCents(operation?.totalout) || 0);
      const expected = requestedCents ?? Math.round(Number(amount || 0) * 100);
      return received === null ? null : Math.max(0, received - returned - expected);
    },
    cashdroAutoChangeToleranceCents() {
      const configured = Number(process.env.VUE_APP_CASHDRO_AUTO_CHANGE_TOLERANCE_CENTS);
      return Number.isFinite(configured) ? Math.max(0, Math.round(configured)) : 99;
    },
    cashdroPaymentNeedsManualCompletion(payment) {
      if (payment.status !== 'failed' || String(payment?.operation?.state || '').toUpperCase() !== 'F') {
        return false;
      }
      const expected = Math.round(Number(payment.amount || 0) * 100);
      const received = this.cashdroCents(payment?.operation?.totalin);
      // New cents-only operations finish automatically. This also lets a
      // cashier settle older failed cards that were persisted before that rule.
      return received !== null && received >= 0 && expected > 0;
    },
    cashdroPaymentReconciliation(payment) {
      const received = this.cashdroCentsToMoney(payment?.operation?.totalin);
      const returned = this.cashdroCentsToMoney(payment?.operation?.totalout);
      if (received === null && returned === null) {
        return '';
      }
      const pending = (this.cashdroPendingChangeCents(payment.operation, payment.amount, payment.cashdroAmountCents) || 0) / 100;
      const details = [
        `Recibido ${this.formatMoney(received || 0)}`,
        `Devuelto ${this.formatMoney(returned || 0)}`,
      ];
      if (pending > 0) {
        details.push(`Pendiente ${this.formatMoney(pending)}`);
      }
      const retained = (received || 0) - (returned || 0);
      const otherPayment = payment.status === 'collected' && payment.collectionId ? Number(payment.methodChange?.received || 0) : 0;
      if (otherPayment > 0) details.push(`Otro método ${this.formatMoney(otherPayment)}`);
      const shortage = Math.max(0, Number(payment.amount || 0) - retained - otherPayment);
      if (shortage > 0) details.push(`Falta cobrar ${this.formatMoney(shortage)}`);
      return details.join(' · ');
    },
    cashdroErrorMessage(error, fallback) {
      if (!error?.response) {
        return 'No se pudo conectar con CashDro. Revisa que esta computadora esté en la red de la tienda y que CashDro permita la conexión.';
      }
      return error.response?.data?.response?.errorMessage
        || error.response?.data?.message
        || error.message
        || fallback;
    },
    cashdroRequestUrl(operation, params = {}) {
      const baseUrl = String(process.env.VUE_APP_CASHDRO_URL || '').trim().replace(/\?$/, '');
      const query = new URLSearchParams({
        operation,
        ...params,
      });
      if (process.env.VUE_APP_CASHDRO_USER) {
        query.set('name', process.env.VUE_APP_CASHDRO_USER);
      }
      if (process.env.VUE_APP_CASHDRO_PASSWORD) {
        query.set('password', process.env.VUE_APP_CASHDRO_PASSWORD);
      }
      return `${baseUrl}?${query.toString()}`;
    },
    async cashdroRequest(operation, params = {}) {
      const headers = process.env.VUE_APP_CASHDRO_AGENT_TOKEN
        ? { 'X-CashDro-Agent-Token': process.env.VUE_APP_CASHDRO_AGENT_TOKEN }
        : {};
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 10000);
      let response;
      let payload;
      try {
        // Use fetch so the CRM's global Axios authorization header never reaches the local agent.
        response = await window.fetch(this.cashdroRequestUrl(operation, params), {
          method: 'GET',
          headers,
          signal: controller.signal,
        });
        const body = await response.text();
        payload = body ? JSON.parse(body) : null;
      } finally {
        window.clearTimeout(timeout);
      }
      if (!response.ok) {
        const error = new Error(payload?.response?.errorMessage || payload?.message || 'No se pudo conectar con CashDro.');
        error.response = { data: payload };
        throw error;
      }
      if (Number(payload?.code) !== 1) {
        const error = new Error(payload?.response?.errorMessage || 'CashDro no pudo procesar la operación.');
        error.response = { data: payload };
        throw error;
      }
      return payload;
    },
    cashdroOperationFromResponse(payload) {
      return payload?.response?.operation?.operation || payload?.response?.operation || {};
    },
    cashdroCents(value) {
      if (value === null || value === undefined || value === '' || Number.isNaN(Number(value))) {
        return null;
      }
      return Math.round(Number(value));
    },
    cashdroOperationCoversPayment(operation, amount, requestedCents = null) {
      if (String(operation?.state || '').toUpperCase() !== 'F') {
        return false;
      }
      const expected = requestedCents ?? Math.round(Number(amount) * 100);
      const totalIn = this.cashdroCents(operation?.totalin);
      const pending = this.cashdroPendingChangeCents(operation, amount, requestedCents);

      return totalIn !== null && totalIn >= expected && pending !== null
        && pending <= this.cashdroAutoChangeToleranceCents();
    },
    startCashdroPolling() {
      if (!this.cashdroConfigured || this.cashdroPollingTimer) {
        return;
      }
      this.cashdroPollingTimer = setInterval(this.pollCashdroPayments, 3000);
      this.pollCashdroPayments();
    },
    stopCashdroPolling() {
      if (this.cashdroPollingTimer) {
        clearInterval(this.cashdroPollingTimer);
        this.cashdroPollingTimer = null;
      }
    },
    async startCashdroPayment(sale) {
      const saleId = sale?.id || this.ticket?.id;
      const paymentMethod = this.selectedPaymentMethodRecord;
      if (!saleId || !paymentMethod?.id) {
        this.snackbar = { show: true, color: 'error', message: 'No se pudo preparar el cobro con CashDro.' };
        return;
      }
      if (this.hasActiveCashdroPayment) {
        this.snackbar = { show: true, color: 'warning', message: 'CashDro está atendiendo otro cobro. Puedes registrar esta venta manualmente o esperar.' };
        return;
      }

      this.loader = true;
      let intent = null;
      let operationId = null;
      try {
        const amount = Number(sale.total || this.subtotal + this.iva || 0);
        const response = await axios.post(
          process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/payment-terminal/intents',
          { sale_id: saleId, payment_method_id: paymentMethod.id, amount, provider: 'cashdro' }
        );
        intent = response.data;
        const entry = {
          intentId: intent.id,
          saleId: Number(saleId),
          amount,
          cashdroAmountCents: Math.ceil(Math.round(amount * 100) / 100) * 100,
          reference: intent.reference,
          status: 'starting',
          operationId: null,
          sale: sale,
          ticket: JSON.parse(JSON.stringify(this.ticket)),
          createdAt: new Date().toISOString(),
          errorMessage: '',
          canceling: false,
          completing: false,
          confirmingPrinted: false,
          imported: false,
        };
        this.cashdroPayments.push(entry);
        this.saveCashdroPayments();

        const started = await this.cashdroRequest('startOperation', {
          type: '4',
          posid: process.env.VUE_APP_CASHDRO_POS_ID || 'UNOCRM-POS',
          posuser: this.currentUser?.name || 'Caja',
          aliasid: intent.reference,
          parameters: JSON.stringify({ amount: String(entry.cashdroAmountCents) }),
        });
        operationId = started?.response?.operation?.operationId;
        if (!operationId) {
          throw new Error('CashDro no regresó el identificador de operación.');
        }
        entry.operationId = String(operationId);
        this.saveCashdroPayments();
        await axios.post(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/payment-terminal/intents/' + entry.intentId + '/cashdro-result', {
          operation_id: entry.operationId, status: 'pending', operation: {}, cashdro_amount_cents: entry.cashdroAmountCents,
        });
        await this.cashdroRequest('acknowledgeOperationId', { operationId: entry.operationId });
        entry.status = 'waiting';
        this.saveCashdroPayments();
        this.releaseCashdroCheckout();
        this.snackbar = { show: true, color: 'success', message: 'Cobro enviado a CashDro. Puedes atender el siguiente ticket.' };
      } catch (error) {
        const entry = this.cashdroPayments.find((payment) => payment.intentId === intent?.id);
        if (entry) {
          entry.operationId = operationId ? String(operationId) : entry.operationId;
          entry.status = entry.operationId ? 'waiting' : 'failed';
          entry.errorMessage = this.cashdroErrorMessage(error, 'No se pudo confirmar el inicio. Revisa CashDro antes de reintentar.');
          // A lost response does not prove that the machine canceled or returned cash.
          this.saveCashdroPayments();
          this.releaseCashdroCheckout();
        }
        this.snackbar = { show: true, color: 'error', message: this.cashdroErrorMessage(error, 'No se pudo iniciar el cobro con CashDro.') };
        // Keep the draft and the intent recoverable if device startup failed.
      } finally {
        this.loader = false;
      }
    },
    releaseCashdroCheckout() {
      this.$store.commit('cart/CLEAR_CART');
      this.savedSale = null;
      this.createdCollectionId = null;
      this.selectedIncomingTicket = null;
      this.pendingSaleId = null;
      this.incomingTicketDirty = false;
      this.cortesia = false;
      this.has_desc = false;
      this.rebajo = 0;
      this.payment_method_ppd = false;
      this.ticket_type = false;
      this.cashReceived = '';
      this.ticket = Object.assign({}, this.ticket, {
        id: '',
        status: 'vendido',
        payment_form: '01',
        payment_method: 'PUE',
        authorized_by: '',
        authorization_reason: '',
      });
      this.ensureClient();
      this.$nextTick(() => this.$refs.searchField?.focus());
    },
    async pollCashdroPayments() {
      if (!this.cashdroConfigured || this.cashdroPolling) {
        return;
      }
      this.cashdroPolling = true;
      try {
        for (const payment of this.cashdroPayments.filter((item) => (
          ['waiting', 'processing'].includes(item.status) || (item.status === 'collected' && !item.imported)
        ))) {
          await this.syncCashdroPayment(payment);
        }
      } finally {
        this.cashdroPolling = false;
      }
    },
    async syncCashdroPayment(payment) {
      if (this.cashdroMethodChange.dialog && this.cashdroMethodChange.intentId === payment.intentId) return;
      if (payment.status === 'collected' && !payment.imported) {
        await this.importCashdroPayment(payment);
        return;
      }
      if (!payment.operationId) {
        return;
      }
      try {
        const result = await this.cashdroRequest('askOperation', { operationId: payment.operationId });
        const operation = this.cashdroOperationFromResponse(result);
        payment.operation = operation;
        const state = String(operation?.state || '').toUpperCase();
        payment.status = state === 'E' ? 'processing' : 'waiting';
        if (state === 'F') {
          const retained = (this.cashdroCents(operation.totalin) || 0) - Math.abs(this.cashdroCents(operation.totalout) || 0);
          const canceled = Number(operation.canceled) === 1 && retained <= 0;
          const status = canceled ? 'canceled' : (this.cashdroOperationCoversPayment(operation, payment.amount, payment.cashdroAmountCents) ? 'approved' : 'failed');
          const response = await axios.post(
            process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/payment-terminal/intents/' + payment.intentId + '/cashdro-result',
            { operation_id: payment.operationId, status, operation, cashdro_amount_cents: payment.cashdroAmountCents }
          );
          const resultIntent = response.data;
          payment.status = resultIntent.status;
          payment.sale = resultIntent.sale?.data || resultIntent.sale || payment.sale;
          payment.collectionId = resultIntent.collection_id || null;
          if (payment.status === 'collected') {
            await this.importCashdroPayment(payment);
            this.snackbar = { show: true, color: 'success', message: `Cobro ${payment.reference} listo para imprimir.` };
          } else if (payment.status !== 'canceled') {
            payment.errorMessage = 'CashDro terminó el cobro con un resultado que requiere revisión.';
          } else {
            payment.errorMessage = '';
          }
        } else {
          await axios.post(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/payment-terminal/intents/' + payment.intentId + '/cashdro-result', {
            operation_id: payment.operationId, status: state === 'E' ? 'processing' : 'pending',
            operation, cashdro_amount_cents: payment.cashdroAmountCents,
          });
        }
        this.saveCashdroPayments();
      } catch (error) {
        payment.errorMessage = this.cashdroErrorMessage(error, 'No se pudo consultar el cobro CashDro.');
        this.saveCashdroPayments();
      }
    },
    async importCashdroPayment(payment) {
      if (payment.imported || !payment.operationId) {
        return;
      }
      try {
        await this.cashdroRequest('setOperationImported', { operationId: payment.operationId });
        payment.imported = true;
        this.saveCashdroPayments();
      } catch (error) {
        payment.errorMessage = 'El cobro quedó registrado, pero CashDro no confirmó la importación. Se reintentará.';
      }
    },
    cashdroCanChangeMethod(payment) {
      return Boolean(payment.operationId) && !payment.collectionId && payment.status !== 'collected';
    },
    openCashdroMethodChange(payment) {
      if (!this.cashdroCanChangeMethod(payment) || this.cashdroMethodChange.dialog) return;
      this.cashdroMethodChange = {
        dialog: true, intentId: payment.intentId, reference: payment.reference, saleId: payment.saleId,
        form: '01', received: '', retained: 0, remaining: 0,
        confirmed: false, ready: false, loading: false, error: '', operation: null,
      };
    },
    closeCashdroMethodChange() {
      if (this.cashdroMethodChange.loading) return;
      this.cashdroMethodChange.dialog = false;
      this.pollCashdroPayments();
    },
    async prepareCashdroMethodChange() {
      const state = this.cashdroMethodChange;
      if (state.loading) return;
      const payment = this.cashdroPayments.find(item => item.intentId === state.intentId);
      if (!payment || !this.cashdroCanChangeMethod(payment)) return;
      state.loading = true;
      state.error = '';
      try {
        await this.ensurePaymentMethods();
        let operation = this.cashdroOperationFromResponse(await this.cashdroRequest('askOperation', { operationId: payment.operationId }));
        if (String(operation.state).toUpperCase() !== 'F') {
          await this.cashdroRequest('finishOperation', { operationId: payment.operationId, type: '2' });
          // Bound the wait; an unconfirmed cancellation never becomes a manual payment.
          for (let attempt = 0; attempt < 5; attempt++) {
            operation = this.cashdroOperationFromResponse(await this.cashdroRequest('askOperation', { operationId: payment.operationId }));
            if (String(operation.state).toUpperCase() === 'F') break;
            await new Promise(resolve => window.setTimeout(resolve, 500));
          }
        }
        const totalIn = this.cashdroCents(operation.totalin);
        const totalOut = this.cashdroCents(operation.totalout);
        if (String(operation.state).toUpperCase() !== 'F' || String(operation.operationid) !== String(payment.operationId)
            || totalIn === null || totalOut === null || totalIn < 0 || totalIn < Math.abs(totalOut)) {
          throw new Error('CashDro aún no confirma el cierre y la devolución. No recibas otro pago ni recaptures la venta; vuelve a consultar.');
        }
        const retained = totalIn - Math.abs(totalOut);
        const remaining = Math.round(payment.amount * 100) - retained;
        if (remaining <= 0) throw new Error('CashDro ya cubrió la venta. Cierra este diálogo y usa Completar o espera la confirmación del cobro.');
        state.operation = operation;
        state.retained = retained / 100;
        state.remaining = remaining / 100;
        state.received = state.remaining.toFixed(2);
        state.ready = true;
        payment.operation = operation;
        this.saveCashdroPayments();
      } catch (error) {
        state.error = error.response ? this.cashdroErrorMessage(error, 'No se pudo preparar el cambio de método.') : error.message;
      } finally {
        state.loading = false;
      }
    },
    async submitCashdroMethodChange() {
      const state = this.cashdroMethodChange;
      if (state.loading || !this.cashdroMethodChangeValid) return;
      const payment = this.cashdroPayments.find(item => item.intentId === state.intentId);
      if (!payment || !this.cashdroCanChangeMethod(payment)) return;
      state.loading = true;
      state.error = '';
      try {
        const response = await axios.post(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/payment-terminal/intents/' + payment.intentId + '/cashdro-change-method', {
          operation_id: String(payment.operationId), operation: state.operation,
          payment_method_id: this.paymentMethodRecord(state.form).id, payment_form: state.form,
          received: Number(state.received), confirmed: true,
        });
        const intent = response.data;
        if (intent.status !== 'collected' || !intent.collection_id) throw new Error('El servidor no confirmó la cobranza. No recaptures la venta.');
        payment.status = intent.status;
        payment.collectionId = intent.collection_id;
        payment.methodChange = intent.method_change || null;
        payment.sale = intent.sale?.data || intent.sale;
        payment.ticket = this.cashdroTicketFromSale(payment.sale);
        payment.operation = intent.operation || state.operation;
        payment.errorMessage = '';
        this.saveCashdroPayments();
        state.dialog = false;
        this.snackbar = { show: true, color: 'success', message: 'Pago registrado sobre la misma venta, sin recapturar productos.' };
        this.printCashdroTicket(payment);
      } catch (error) {
        state.error = error.response ? this.cashdroErrorMessage(error, 'No se pudo cambiar el método de pago.') : error.message;
      } finally {
        state.loading = false;
      }
    },
    completeCashdroPayment(payment) {
      if (this.cashdroCompletion.loading || !this.cashdroPaymentNeedsManualCompletion(payment)) return;
      const pending = this.cashdroPendingChangeCents(payment.operation, payment.amount, payment.cashdroAmountCents) || 0;
      const retained = (this.cashdroCents(payment.operation?.totalin) || 0) - Math.abs(this.cashdroCents(payment.operation?.totalout) || 0);
      const expected = Math.round(payment.amount * 100);
      const shortage = Math.max(0, expected - retained) / 100;
      this.cashdroCompletion = {
        dialog: true, intentId: payment.intentId, reference: payment.reference,
        shortage, pending: pending / 100, manualReceived: shortage > 0 ? shortage.toFixed(2) : '',
        confirmed: false, loading: false, error: '',
      };
    },
    async submitCashdroCompletion() {
      if (this.cashdroCompletion.loading || !this.cashdroCompletionValid) return;
      const payment = this.cashdroPayments.find(item => item.intentId === this.cashdroCompletion.intentId);
      if (!payment || !this.cashdroPaymentNeedsManualCompletion(payment)) {
        this.cashdroCompletion.error = 'El estado del cobro cambió. Cierra este diálogo y revisa la tarjeta.';
        return;
      }
      const manualReceived = this.cashdroCompletion.shortage > 0 ? Number(this.cashdroCompletion.manualReceived) : 0;
      const retained = (this.cashdroCents(payment.operation?.totalin) || 0) - Math.abs(this.cashdroCents(payment.operation?.totalout) || 0);
      if (retained + Math.round(manualReceived * 100) < Math.round(payment.amount * 100)) {
        this.cashdroCompletion.error = 'El efectivo confirmado no cubre el total de la venta.';
        return;
      }
      this.cashdroCompletion.loading = true;
      this.cashdroCompletion.error = '';
      payment.completing = true;
      try {
        const response = await axios.post(
          process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/payment-terminal/intents/' + payment.intentId + '/cashdro-result',
          { operation_id: payment.operationId, status: 'approved', operation: payment.operation, manual_completion: true, manual_received: manualReceived, cashdro_amount_cents: payment.cashdroAmountCents }
        );
        const resultIntent = response.data;
        payment.status = resultIntent.status;
        payment.sale = resultIntent.sale?.data || resultIntent.sale || payment.sale;
        payment.collectionId = resultIntent.collection_id || null;
        if (payment.status === 'collected') {
          this.cashdroCompletion.dialog = false;
          await this.importCashdroPayment(payment);
          this.snackbar = { show: true, color: 'success', message: `Cobro ${payment.reference} listo para imprimir.` };
          this.printCashdroTicket(payment);
        }
      } catch (error) {
        this.cashdroCompletion.error = this.cashdroErrorMessage(error, 'No se pudo completar el cobro CashDro.');
      } finally {
        this.cashdroCompletion.loading = false;
        payment.completing = false;
        this.saveCashdroPayments();
      }
    },
    async cancelCashdroPayment(payment) {
      payment.canceling = true;
      try {
        if (payment.operationId) {
          await this.cashdroRequest('finishOperation', { operationId: payment.operationId, type: '2' });
          const result = await this.cashdroRequest('askOperation', { operationId: payment.operationId });
          payment.operation = this.cashdroOperationFromResponse(result);
          await axios.post(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/payment-terminal/intents/' + payment.intentId + '/cashdro-result', {
            operation_id: payment.operationId, status: 'canceled', operation: payment.operation,
            cashdro_amount_cents: payment.cashdroAmountCents,
          });
        } else {
          await axios.delete(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/payment-terminal/intents/' + payment.intentId);
        }
        payment.status = 'canceled';
        payment.errorMessage = '';
        this.saveCashdroPayments();
      } catch (error) {
        this.snackbar = { show: true, color: 'error', message: this.cashdroErrorMessage(error, 'No se pudo cancelar el cobro CashDro.') };
      } finally {
        payment.canceling = false;
      }
    },
    editCashdroSale(payment) {
      if (!this.cashdroCanModify(payment)) return;
      this.cashdroEnabled = true;
      if (!payment.sale?.id) {
        return;
      }
      this.selectedIncomingTicket = null;
      this.pendingSaleId = payment.sale.id;
      this.applyIncomingTicket(payment.sale);
      this.snackbar = { show: true, color: 'info', message: 'Borrador cargado para modificar productos y volver a cobrar con CashDro.' };
    },
    async printCashdroTicket(payment) {
      if (payment.status !== 'collected' || !payment.collectionId) {
        this.snackbar = { show: true, color: 'error', message: 'Esta venta no tiene cobranza ligada. Completa o concilia el cobro antes de imprimir.' };
        return;
      }
      if (!payment.ticket) {
        this.snackbar = { show: true, color: 'error', message: 'No se encontró el ticket de este cobro.' };
        return;
      }
      this.ticket = payment.ticket;
      this.savedSale = payment.sale;
      this.createdCollectionId = payment.collectionId || null;
      this.cashdroPrintPaymentId = payment.intentId;
      this.ticket_type = payment.sale?.type === 'Serie A';
      if (this.ticket_type && !payment.sale?.invoice && !(payment.sale?.facturapi_invoices || []).length) {
        this.prepareInvoice(payment.sale);
        this.invoiceDialog = true;
      } else {
        if (!this.ticket_type && !payment.sale?.self_invoice_url) {
          try {
            const response = await axios.post(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/sales/' + payment.saleId + '/receipt', {
              receipt: { payment_form: payment.sale?.payment_form || '01', items: (payment.sale?.items || []).map(item => ({
                quantity: Number(item.quantity), product: this.facturapi_product_id(item.item || item.product, Number(item.price)),
              })) },
            });
            payment.sale = response.data.data || response.data;
            this.ticket.self_invoice_url = payment.sale.self_invoice_url;
            this.saveCashdroPayments();
          } catch (error) {
            this.snackbar = { show: true, color: 'warning', message: 'Cobro completado. No se pudo generar el QR de autofactura; el ticket se puede imprimir.' };
          }
        }
        this.dialogTicket = true;
      }
    },
    async startTerminalPayment(sale) {
      const saleId = sale?.id || this.ticket?.id;
      const paymentMethod = this.selectedPaymentMethodRecord;
      if (!saleId || !paymentMethod?.id) {
        this.snackbar = {
          message: "No se pudo iniciar el cobro con terminal.",
          color: "error",
          show: true,
        };
        return;
      }

      this.terminalPayment = {
        ...this.terminalPayment,
        dialog: true,
        loading: true,
        canceling: false,
        status: 'pending',
        amount: Number(sale.total || this.subtotal + this.iva || 0),
        reference: '',
        errorMessage: '',
        clipError: '',
        retryable: false,
        pollErrors: 0,
        manualConfirmationAvailable: false,
        manualPaymentForm: null,
        manualReceiptNumber: '',
        manualConfirmed: false,
      };
      this.startManualClipConfirmationTimer();

      try {
        const response = await axios.post(
          process.env.VUE_APP_BACKEND_ROUTE + "api/v2/payment-terminal/intents",
          {
            sale_id: saleId,
            payment_method_id: paymentMethod.id,
            amount: this.terminalPayment.amount,
          }
        );
        await this.applyTerminalPaymentResponse(response.data);
        if (!response.data.ready_to_print) {
          this.startTerminalPaymentPolling();
        }
      } catch (error) {
        this.clearManualClipConfirmationTimer();
        this.terminalPayment.loading = false;
        this.terminalPayment.status = 'failed';
        this.terminalPayment.errorMessage = this.apiErrorMessage(error, "No se pudo iniciar el cobro con terminal.");
        this.snackbar = {
          message: this.terminalPayment.errorMessage,
          color: "error",
          show: true,
        };
      }
    },
    async ensureTerminalReceipt(sale) {
      if (!sale?.id || sale.self_invoice_url) {
        return sale;
      }

      try {
        const response = await axios.post(
          process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/sales/' + sale.id + '/receipt',
          {
            receipt: {
              payment_form: sale.payment_form || '28',
              items: (sale.items || []).map((item) => ({
                quantity: Number(item.quantity),
                product: this.facturapi_product_id(item.item || item.product, Number(item.price)),
              })),
            },
          }
        );
        const updatedSale = response.data.data || response.data;
        this.savedSale = updatedSale;
        this.ticket.self_invoice_url = updatedSale.self_invoice_url || this.ticket.self_invoice_url;
        return updatedSale;
      } catch (error) {
        this.snackbar = {
          show: true,
          color: 'warning',
          message: 'Cobro aprobado. No se pudo generar el QR de autofactura; el ticket se puede imprimir.',
        };
        return sale;
      }
    },
    async applyTerminalPaymentResponse(data) {
      this.terminalPayment.id = data.id;
      this.terminalPayment.status = data.status;
      this.terminalPayment.retryable = Boolean(data.retryable);
      this.terminalPayment.clipError = data.error_message || '';
      this.terminalPayment.reference = data.reference;
      this.terminalPayment.amount = data.amount;
      this.createdCollectionId = data.collection_id || this.createdCollectionId;
      if (data.sale) {
        const sale = data.sale.data || data.sale;
        this.savedSale = sale;
      }
      if (data.ready_to_print) {
        this.stopTerminalPaymentPolling();
        this.terminalPayment.loading = false;
        this.terminalPayment.dialog = false;
        this.clipTerminalEnabled = true;
        this.selectedIncomingTicket = null;
        this.incomingTicketDirty = false;
        const hasInvoice = Boolean(this.savedSale?.invoice)
          || Boolean((this.savedSale?.facturapi_invoices || []).length);
        if (this.ticket_type && !this.is_quotation && !hasInvoice) {
          this.prepareInvoice(this.savedSale || {});
          this.invoiceDialog = true;
        } else {
          if (!this.ticket_type && !this.is_quotation) {
            await this.ensureTerminalReceipt(this.savedSale);
          }
          this.dialogTicket = true;
        }
      }
      if (data.status === 'canceled' || (data.status === 'failed' && !data.retryable)) {
        this.stopTerminalPaymentPolling();
        this.terminalPayment.loading = false;
      } else if (data.status === 'failed') {
        // Keep polling: the customer can retry the card on the same Clip request.
        this.terminalPayment.loading = false;
        this.clearManualClipConfirmationTimer();
      }
    },
    startTerminalPaymentPolling() {
      this.stopTerminalPaymentPolling();
      this.terminalPayment.pollTimer = setInterval(this.pollTerminalPayment, 2500);
    },
    stopTerminalPaymentPolling() {
      if (this.terminalPayment.pollTimer) {
        clearInterval(this.terminalPayment.pollTimer);
        this.terminalPayment.pollTimer = null;
      }
      this.clearManualClipConfirmationTimer();
    },
    startManualClipConfirmationTimer() {
      this.clearManualClipConfirmationTimer();
      this.terminalPayment.manualConfirmationTimer = setTimeout(() => {
        this.terminalPayment.manualConfirmationAvailable = true;
      }, 60000);
    },
    clearManualClipConfirmationTimer() {
      if (this.terminalPayment.manualConfirmationTimer) {
        clearTimeout(this.terminalPayment.manualConfirmationTimer);
        this.terminalPayment.manualConfirmationTimer = null;
      }
    },
    async pollTerminalPayment() {
      if (!this.terminalPayment.id) {
        return;
      }
      try {
        const response = await axios.get(
          process.env.VUE_APP_BACKEND_ROUTE + "api/v2/payment-terminal/intents/" + this.terminalPayment.id
        );
        this.terminalPayment.pollErrors = 0;
        await this.applyTerminalPaymentResponse(response.data);
      } catch (error) {
        // Keep polling through network hiccups so an approved charge still prints.
        this.terminalPayment.pollErrors += 1;
        if (this.terminalPayment.pollErrors === 3) {
          this.snackbar = {
            message: "No se pudo consultar el cobro con terminal. Se sigue intentando...",
            color: "warning",
            show: true,
          };
        }
      }
    },
    async requestTerminalCancel() {
      const response = await axios.delete(
        process.env.VUE_APP_BACKEND_ROUTE + "api/v2/payment-terminal/intents/" + this.terminalPayment.id,
        { params: { resolve: 1 } }
      );
      return response.data || {};
    },
    async cancelTerminalPayment() {
      if (!this.terminalPayment.id) {
        await this.returnToEditableSale();
        return;
      }
      this.terminalPayment.canceling = true;
      try {
        const data = await this.requestTerminalCancel();
        if (data.status === 'collected') {
          // Clip approved the charge before it could be canceled: print it.
          await this.applyTerminalPaymentResponse(data);
          return;
        }
        this.stopTerminalPaymentPolling();
        this.terminalPayment.status = 'canceled';
        this.terminalPayment.retryable = false;
        await this.returnToEditableSale();
      } catch (error) {
        this.snackbar = {
          message: this.apiErrorMessage(error, "No se pudo cancelar el cobro con terminal."),
          color: "error",
          show: true,
        };
      } finally {
        this.terminalPayment.canceling = false;
      }
    },
    async confirmClipPayment() {
      if (!this.canSubmitManualClipPayment || !this.terminalPayment.id) {
        return;
      }

      this.terminalPayment.manualLoading = true;
      try {
        const response = await axios.post(
          process.env.VUE_APP_BACKEND_ROUTE + "api/v2/payment-terminal/intents/" + this.terminalPayment.id + "/confirm-clip-payment",
          {
            payment_form: this.terminalPayment.manualPaymentForm,
            receipt_number: this.terminalPayment.manualReceiptNumber,
            confirmed: true,
          }
        );
        await this.applyTerminalPaymentResponse(response.data);
      } catch (error) {
        this.snackbar = {
          message: this.apiErrorMessage(error, "No se pudo confirmar el cobro de Clip."),
          color: "error",
          show: true,
        };
      } finally {
        this.terminalPayment.manualLoading = false;
      }
    },
    async handleTerminalCancelAction() {
      if (this.terminalPaymentIsClosed) {
        await this.returnToEditableSale();
        return;
      }
      await this.cancelTerminalPayment();
    },
    async returnToEditableSale() {
      this.stopTerminalPaymentPolling();
      this.terminalPayment.loading = false;
      this.clipTerminalEnabled = true;
      const saleWasCanceled = await this.cancelSavedSale();
      if (saleWasCanceled) {
        this.terminalPayment.dialog = false;
      }
    },
    async continueWithoutClip() {
      this.terminalPayment.manualLoading = true;
      if (this.terminalPayment.retryable && this.terminalPayment.id) {
        // Close the Clip request first so the card can't be charged as well.
        try {
          const data = await this.requestTerminalCancel();
          if (data.status === 'collected') {
            await this.applyTerminalPaymentResponse(data);
            this.terminalPayment.manualLoading = false;
            return;
          }
          this.terminalPayment.status = 'canceled';
          this.terminalPayment.retryable = false;
        } catch (error) {
          this.snackbar = {
            message: this.apiErrorMessage(error, "No se pudo cancelar el cobro con terminal."),
            color: "error",
            show: true,
          };
          this.terminalPayment.manualLoading = false;
          return;
        }
      }
      this.stopTerminalPaymentPolling();
      try {
        const collectionWasCreated = await this.createCollection(this.savedSale || {});
        if (!collectionWasCreated) {
          return;
        }
        this.terminalPayment.dialog = false;
        this.terminalPayment.loading = false;
        this.clipTerminalEnabled = true;
        this.selectedIncomingTicket = null;
        this.incomingTicketDirty = false;
        this.dialogTicket = true;
      } finally {
        this.terminalPayment.manualLoading = false;
      }
    },
    apiErrorMessage(error, fallback) {
      const data = error?.response?.data || {};
      const firstError = data.errors && Object.values(data.errors).flat()[0];
      return data.message && data.message !== "The given data was invalid."
        ? data.message
        : (firstError || fallback);
    },
    async cancelSavedSale() {
      const saleId = this.savedSale?.id || this.ticket?.id;
      if (!saleId || this.cancelSaleLoading) {
        return !saleId;
      }

      this.cancelSaleLoading = true;
      try {
        if (this.createdCollectionId) {
          await axios.delete(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/collections/" + this.createdCollectionId);
        }
        await axios.delete(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sales/" + saleId);

        this.savedSale = null;
        this.createdCollectionId = null;
        this.invoiceDialog = false;
        this.dialogTicket = false;
        this.loader = false;
        this.ticket.id = "";
        this.ticket.self_invoice_url = "";

        this.snackbar = {
          message: "Venta cancelada. El carrito quedó precargado para corregirla.",
          color: "success",
          show: true,
        };
        return true;
      } catch (error) {
        this.snackbar = {
          message: error.response?.data?.message || "No se pudo cancelar la venta.",
          color: "error",
          show: true,
        };
        return false;
      } finally {
        this.cancelSaleLoading = false;
      }
    },
    async handleInvoiceClose(invoice) {
      this.invoiceDialog = false;
      if (invoice?.invoice_later) {
        const serieWasUpdated = await this.markSavedSaleAsSerieB();
        if (!serieWasUpdated) {
          return;
        }
      }
      if (this.terminalPayment.status === 'collected') {
        this.selectedIncomingTicket = null;
        this.incomingTicketDirty = false;
        this.dialogTicket = true;
        return;
      }
      this.finalizeSaleFlow();
    },
    async markSavedSaleAsSerieB() {
      const saleId = this.savedSale?.id || this.invoicePayload?.external_id;
      if (!saleId) {
        return false;
      }

      try {
        await axios.patch(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sales/" + saleId, {
          type: "Serie B",
        });
        this.ticket_type = false;
        if (this.savedSale) {
          this.savedSale.type = "Serie B";
        }
        if (this.ticket) {
          this.ticket.type = "Serie B";
          this.ticket.self_invoice_url = this.ticket.self_invoice_url || "";
        }
        return true;
      } catch (error) {
        this.snackbar = {
          message: error.response?.data?.message || "No se pudo dejar la venta como Serie B.",
          color: "error",
          show: true,
        };
        return false;
      }
    },
    save() {
      if (this.selectedIncomingTicket?.status === 'cashdro_draft' && !this.isCashdroPayment) {
        this.snackbar = { show: true, color: 'warning', message: 'Guarda este borrador con CashDro. Para recibir efectivo manualmente usa Completar en su cobro.' };
        return;
      }
      const pendingSaleId = this.pendingSaleId;
      const isIncomingTicketSave = pendingSaleId !== null && pendingSaleId !== undefined;
      const createdByUserId = isIncomingTicketSave
        ? this.incomingCreatedByUserId()
        : this.currentUser.id;
      const lastUpdatedByUserId = isIncomingTicketSave
        ? (this.incomingTicketDirty ? this.currentUser.id : this.incomingLastUpdatedByUserId())
        : this.currentUser.id;
      if (this.cortesia) {
        this.ticket.status = "cortesia";
      }
      if (this.is_quotation) {
        this.ticket.status = "quotation";
      }
      this.selectedPaymentForm = this.ticket.payment_form;
      this.loader = true;
      const serie = this.ticket_type ? "Serie A" : "Serie B";
      // Clip tells us the actual card type only after approval. Create the
      // autofactura receipt then, so its SAT payment form is accurate.
      const deferReceiptForTerminal = this.requiresTerminalPayment
        && !this.ticket_type
        && !this.is_quotation;

      this.ticket = {
        company_id: this.client.id,
        user_id: this.currentUser.id,
        note: "",
        items: this.StoreCart.map((item) => ({
          quantity: item.quantity * 1,
          item: item.product.id,
          price: this.discountedUnitPrice(item),
          discount: this.lineDiscountAmount(item),
          cost: item.product.cost,
          value: this.productOriginalPrice(item.product),
        })),
        status: this.isCashdroPayment && !this.is_quotation && !this.payment_method_ppd ? 'cashdro_draft' : this.ticket.status,
        bar: 1,
        subtotal: this.subtotal,
        iva: this.iva,
        total: this.subtotal + this.iva,
        date: new Date()
          .toLocaleString("sv-SE", { timeZone: "America/Monterrey" })
          .toString()
          .slice(0, 10),
        created_by_user_id: createdByUserId,
        last_updated_by_user_id: lastUpdatedByUserId,
        id: "",
        self_invoice_url: "",
        type: serie,
        ...(!deferReceiptForTerminal ? {
          receipt: {
            items: this.StoreCart.map((item) => ({
              quantity: item.quantity * 1,
              product: this.facturapi_product_id(item.product, this.discountedUnitPrice(item)),
            })),
            payment_form: this.selectedPaymentForm,
          },
        } : {}),
        payment_form: this.selectedPaymentForm,
        payment_method: this.cualMetodo,
        authorized_by: this.ticket.authorized_by,
        authorization_reason: this.ticket.authorization_reason,
      };

      const endpoint = this.is_quotation
        ? "quotations"
        : (this.isCashdroPayment ? "cashdro/drafts" : (this.ticket_type ? "sales" : "sale/pos"));
      if (this.isCashdroPayment && pendingSaleId && this.selectedIncomingTicket?.status === 'cashdro_draft') {
        this.ticket.draft_id = pendingSaleId;
      }

      axios
        .post(
          process.env.VUE_APP_BACKEND_ROUTE + "api/v2/" + endpoint,
          this.ticket
        )
        .then((response) => {
          const resp = response.data.data;
          this.savedSale = resp;
          this.ticket = {
            id: resp.id,
            company_id: resp.company.id,
            company: resp.company,
            note: resp.note,
            bar: resp.bar,
            subtotal: resp.subtotal,
            iva: resp.iva,
            total: resp.total,
            date: resp.date,
            created_at: resp.created_at,
            user_id: this.currentUser.id,
            user: this.currentUser,
            items: resp.items.map((i) => ({
              quantity: i.quantity,
              product: i.item,
              price: i.price,
              value: i.value ?? i.item?.original_price ?? i.price,
              discount: i.discount ?? 0,
            })),
            status: resp.status,
            self_invoice_url: resp.self_invoice_url,
            payment_form: this.selectedPaymentForm,
            payment_method: this.cualMetodo,
          };
          if (pendingSaleId && !this.isCashdroPayment) {
            axios
              .delete(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/sales/" + pendingSaleId)
              .catch((error) => {
                this.snackbar = {
                  message: error.response?.data?.message || "No se pudo eliminar la venta pendiente.",
                  color: "error",
                  show: true,
                };
              })
              .finally(() => {
                this.pendingSaleId = null;
                this.incomingTicketDirty = false;
              });
          }
          if (this.ticket_type && !this.is_quotation && !this.isCashdroPayment && !this.requiresTerminalPayment) {
            this.prepareInvoice(resp);
            this.invoiceDialog = true;
          } else {
            this.finalizeSaleFlow();
          }
        })
        .catch((error) => {
          if (this.is_quotation) {
            this.is_quotation = false;
          }
          this.snackbar = {
            message: error.response?.data?.message || "Error al guardar la venta.",
            color: "error",
            show: true,
          };
        })
        .finally(() => {
          this.loader = false;
        });
    },
    async confirmCashdroPrinted(payment) {
      if (payment.status !== 'collected' || payment.confirmingPrinted) return false;
      this.$set(payment, 'confirmingPrinted', true);
      try {
        await axios.post(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/payment-terminal/intents/' + payment.intentId + '/cashdro-printed');
        this.cashdroPayments = this.cashdroPayments.filter(item => item.intentId !== payment.intentId);
        this.saveCashdroPayments();
        return true;
      } catch (error) {
        this.snackbar = { show: true, color: 'warning', message: this.cashdroErrorMessage(error, 'La venta ya está cobrada. No se pudo confirmar el ticket; vuelve a intentar cerrar el ticket.') };
        return false;
      } finally {
        payment.confirmingPrinted = false;
      }
    },
    async cerrarTicket() {
      if (this.cashdroClosingTicket) return;
      if (this.cashdroPrintPaymentId) {
        const payment = this.cashdroPayments.find(item => item.intentId === this.cashdroPrintPaymentId);
        if (!payment) return;
        this.cashdroClosingTicket = true;
        try {
          if (!await this.confirmCashdroPrinted(payment)) return;
        } finally {
          this.cashdroClosingTicket = false;
        }
      }
      this.dialogTicket = false;
      this.clipTerminalEnabled = true;
      if (this.cashdroPrintPaymentId) {
        this.cashdroPayments = this.cashdroPayments.filter(
          (payment) => payment.intentId !== this.cashdroPrintPaymentId
        );
        this.cashdroPrintPaymentId = null;
        this.saveCashdroPayments();
      }
      location.reload();
    },
    facturapi_product_id(product, priceOverride = null) {
      if (!product.sat_key_code) {
        product.sat_key_code = product.new_sat_key_code;
      }
      return {
        description: product.name,
        product_key: product.sat_key_code,
        price: priceOverride !== null ? Number(priceOverride) : product.price,
        tax_included:
          process.env.VUE_APP_BACKEND_ROUTE === "https://backendmf.unocrm.mx/" ? undefined : false,
        taxability:
          process.env.VUE_APP_BACKEND_ROUTE === "https://backendmf.unocrm.mx/" ? "02" : "02",
        taxes:
          process.env.VUE_APP_BACKEND_ROUTE === "https://backendmf.unocrm.mx/"
            ? [
                {
                  type: "IVA",
                  rate: 0,
                },
              ]
            : [
                {
                  type: "IVA",
                  rate: 0.16,
                },
              ],
        sku: product.code_one,
        unit_key: "H87",
        unit_name: "Pieza",
      };
    },
  },
};
</script>

<style scoped>
.homedepot {
  --accent: #f37021;
  --dark: #3e3e3e;
  --panel: #f7f7f7;
  background: #f2f2f2;
  min-height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.homedepot-main {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  overflow-y: auto;
}

.left-pane {
  padding: 16px;
}

.right-pane {
  padding: 16px;
  background: #efefef;
  border-left: 2px solid #dedede;
}

.search-card {
  background: #ffffff;
  padding: 8px 12px;
  margin-bottom: 12px;
}

.ticket-strip {
  background: #ffffff;
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 12px;
}

.ticket-strip-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-weight: 700;
  color: #6b5a2a;
  margin-bottom: 8px;
}

.cash-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.ticket-strip-list {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.cashdro-strip {
  background: #f6fbf5;
  border: 1px solid #c9ddc5;
  border-radius: 12px;
  padding: 10px 12px;
  margin-bottom: 12px;
}

.cashdro-strip-title,
.cashdro-payment,
.cashdro-payment-actions {
  display: flex;
  align-items: center;
}

.cashdro-strip-title {
  justify-content: space-between;
  color: #356c35;
  font-weight: 700;
  margin-bottom: 6px;
}

.cashdro-count {
  min-width: 22px;
  padding: 1px 7px;
  border-radius: 12px;
  background: #4d8a4d;
  color: white;
  text-align: center;
}

.cashdro-payment-list {
  display: grid;
  gap: 6px;
  max-height: 240px;
  overflow-y: auto;
}

.cashdro-payment {
  justify-content: space-between;
  gap: 12px;
  padding: 7px 0;
  border-top: 1px solid #dcebd8;
}

.cashdro-payment strong,
.cashdro-payment span {
  display: block;
}

.cashdro-payment span:not(.cashdro-status) {
  color: #6f6f6f;
  font-size: 11px;
}

.cashdro-reconciliation {
  display: block;
  max-width: 330px;
  color: #b3261e;
  font-size: 11px;
  line-height: 1.3;
}

.cashdro-payment-actions {
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.cashdro-status {
  font-size: 12px;
  font-weight: 600;
  color: #587557;
}

.cashdro-status--collected {
  color: #2e7d32;
}

.cashdro-status--failed,
.cashdro-status--canceled {
  color: #c62828;
}

.ticket-card {
  padding: 10px 12px;
  border-radius: 10px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  min-width: 180px;
  flex: 0 0 auto;
}

.ticket-card--selected {
  border: 2px solid #e25104 !important;
  box-shadow: 0 0 0 2px rgba(226, 81, 4, 0.15);
}

.ticket-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

.ticket-card-id {
  font-weight: 700;
  color: #e25104;
  margin-bottom: 4px;
}

.ticket-card-name {
  font-weight: 600;
  font-size: 14px;
  color: #3f3f3f;
}

.ticket-card-meta {
  font-size: 12px;
  color: #7a7a7a;
}

.cart-card {
  background: #ffffff;
  padding: 0;
  min-height: calc(100vh - 280px);
  max-height: calc(100vh - 280px);
  overflow: auto;
}

.mini-cart-card {
  background: #ffffff;
  padding: 0;
  min-height: calc(100vh - 350px);
  max-height: calc(100vh - 350px);
  overflow: auto;
}

.cart-header {
  font-weight: 700;
  font-size: 18px;
  padding: 16px 16px 8px 16px;
  color: var(--dark);
}

.cart-count {
  color: var(--accent);
}

.cart-list {
  max-height: calc(100vh - 260px);
  overflow-y: auto;
}

.cart-item {
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #e0e0e0;
}

.item-qty {
  font-size: 20px;
  font-weight: 700;
  color: var(--accent);
  width: 100px;
  text-align: center;
}

.item-details {
  flex: 1;
}

.item-name {
  font-weight: 600;
}

.item-meta {
  font-size: 12px;
  color: #777;
}

.item-price {
  font-size: 13px;
  color: #4f4f4f;
}

.item-total {
  font-weight: 700;
  color: #3f3f3f;
  margin-right: 8px;
}

.item-actions {
  display: flex;
  gap: 4px;
}

.price-edit,
.sat-edit {
  max-width: 200px;
}

.empty-cart {
  padding: 24px;
  color: #888;
  text-align: center;
}

.summary-card {
  background: #f6f6f6;
  padding: 16px;
  border: 1px solid #e0e0e0;
  min-height: calc(100vh - 145px);
  max-height: calc(100vh - 145px);
  overflow: auto;
}

.summary-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--accent);
  margin-bottom: 8px;
}

.summary-meta {
  font-size: 14px;
  color: #5b5b5b;
}

.client-autocomplete {
  margin-bottom: 12px;
}

.client-subtitle {
  font-size: 12px;
  color: #6b6b6b;
}

.discount-box {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.discount-toggle {
  display: flex;
  align-items: center;
}

.payment-section {
  margin-top: 12px;
}

.section-label {
  font-weight: 600;
  margin-bottom: 8px;
}

.payment-chip {
  margin-bottom: 6px;
}

.cash-section {
  margin-top: 16px;
  padding: 12px;
  background: #fff7ef;
  border: 1px solid #f1d8c0;
  border-radius: 10px;
}

.payment-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.clip-terminal-switch {
  margin-top: 0;
  padding-top: 0;
}

.cash-input {
  margin-bottom: 8px;
}

.cash-change {
  font-weight: 600;
  color: #2f7a34;
}

.cash-change.negative {
  color: #c62828;
}

.cash-warning {
  color: #c62828;
  font-size: 12px;
  font-weight: 600;
  margin-top: 4px;
}

.cashdro-section {
  background: #f3fbf1;
  border-color: #c7dec1;
}

.cashdro-help {
  color: #577057;
  font-size: 13px;
  line-height: 1.4;
}

.bottom-bar {
  flex: 0 0 69px;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  background: #3b3b3b;
  color: white;
  padding: 12px 24px;
}

.totals {
  display: flex;
  gap: 32px;
}

.total-block .label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #d2d2d2;
  text-align:center;
}

.total-block .value {
  font-size: 18px;
  font-weight: 700;
}

.action-col,
.action-row,
.action-cell, .v-btn:not(.v-btn--round).v-size--default {
  height: 69px!important;
  min-height: 100%!important;
}

.action-btn {
  height: 100%;
  border-radius: 0;
  font-weight: 700;
}

.result-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.result-price {
  font-weight: 700;
  margin-right: 16px;
}

.terminal-payment-total {
  font-size: 32px;
  font-weight: 700;
  color: #212121;
  margin: 12px 0 4px;
}

@media (max-width: 960px) {
  .homedepot {
    max-height: none;
    overflow: visible;
  }

  .homedepot-main {
    flex: none;
    min-height: auto;
    overflow: visible;
  }

  .bottom-bar {
    flex: none;
    flex-direction: column;
    gap: 12px;
  }
}
</style>
